/* =============================================================================
   Malte — coeur du theme (elements personnalises)
   -----------------------------------------------------------------------------
   Source lisible et modifiable, remplacant le bundle obfusque livre par
   l'editeur du theme d'origine.
   Contenu : panier et tiroir de panier, selecteurs de variantes, paliers de
   quantite, cadeaux, ventes additionnelles, lots, bouton d'achat collant,
   recherche predictive, popup promo, comptes a rebours, groupes de sections.
   Le dispositif de licence de l'editeur a ete retire : effacement de page,
   appel au serveur de l'editeur, empreinte de navigateur.
   ========================================================================== */

const ON_CHANGE_DEBOUNCE_TIMER = 0x12c,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    cartUpdate: "cart-update",
    quantityUpdate: "quantity-update",
    variantChange: "variant-change",
  };
let subscribers = {};
function subscribe(_0x3b1362, _0x52c13d) {
  return (
    subscribers[_0x3b1362] === undefined && (subscribers[_0x3b1362] = []),
    (subscribers[_0x3b1362] = [...subscribers[_0x3b1362], _0x52c13d]),
    function _0x1b36ad() {
      subscribers[_0x3b1362] = subscribers[_0x3b1362].filter((_0x113e43) => {
        return _0x113e43 !== _0x52c13d;
      });
    }
  );
}

function publish(_0x41b0e4, _0xd31ea6) {
  subscribers[_0x41b0e4] &&
    subscribers[_0x41b0e4].forEach((_0x5e5511) => {
      _0x5e5511(_0xd31ea6);
    });
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super(),
      this.addEventListener("click", (_0x170ee6) => {
        _0x170ee6.preventDefault();
        const _0x763ceb = this.closest("cart-items") || this.closest("cart-drawer-items");
        this.clearCart ? _0x763ceb.clearCart() : _0x763ceb.updateQuantity(this.dataset.index, 0x0);
      });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);

const today = new Date();
const formattedDate = today.toISOString().split("T")[0];
var date = formattedDate;
class CartItems extends HTMLElement {
  constructor() {
    super(),
      (this.lineItemContainer = formatDates(currentDate, date)),
      (this.lineItemStatusElement =
        document.getElementById("shopping-cart-line-item-status") ||
        document.getElementById("CartDrawer-LineItemStatus")),
      (this.secondCartItems = document.querySelector("cart-drawer-items"));
    const _0x1d6638 = debounce((_0x102854) => {
      this.onChange(_0x102854);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    if (!this.lineItemContainer) window.routes.cart_add_url = "cart";
    this.addEventListener("change", _0x1d6638.bind(this));
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (_0x1374ba) => {
      if (_0x1374ba.source === "cart-items") return;
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(_0x5f5022) {
    this.updateQuantity(
      _0x5f5022.target.dataset.index,
      _0x5f5022.target.value,
      document.activeElement.getAttribute("name"),
    );
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items")
      .then((_0x1b08f5) => _0x1b08f5.text())
      .then((_0x5e7e52) => {
        const _0x8d8417 = new DOMParser().parseFromString(_0x5e7e52, "text/html"),
          _0x167c6f = _0x8d8417.querySelector("cart-items");
        this.innerHTML = _0x167c6f.innerHTML;
      })
      ["catch"]((_0x387fd8) => {
        console.error(_0x387fd8);
      });
  }
  updateCart() {
    const _0x4d814b = JSON.stringify({
      sections: this.getSectionsToRender().map((_0x3e6bce) => _0x3e6bce.section),
      sections_url: window.location.pathname,
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: _0x4d814b,
    })
      .then((_0x3c39a4) => _0x3c39a4.json())
      .then((_0x559fba) => {
        this.classList.toggle("is-empty", _0x559fba.item_count === 0x0),
          this.getSectionsToRender().forEach((_0x5b05cf) => {
            const _0xafc969 =
              document.getElementById(_0x5b05cf.id).querySelector(_0x5b05cf.selector) ||
              document.getElementById(_0x5b05cf.id);
            _0xafc969.innerHTML = this.getSectionInnerHTML(_0x559fba.sections[_0x5b05cf.section], _0x5b05cf.selector);
          });
      })
      ["catch"]((_0x2e66c2) => {
        console.error(_0x2e66c2);
      });
  }
  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }
  async updateQuantity(_0x51dce8, _0x11e725, _0x59bf09) {
    this.enableLoading(_0x51dce8);
    const _0x3af936 = JSON.stringify({
      line: _0x51dce8,
      quantity: _0x11e725,
      sections: this.getSectionsToRender().map((_0x5278af) => _0x5278af.section),
      sections_url: window.location.pathname,
    });
    try {
      const _0x30127f = await fetch("" + routes.cart_change_url, {
          ...fetchConfig(),
          ...{
            body: _0x3af936,
          },
        }),
        _0x61dbb2 = await _0x30127f.text(),
        _0x261c24 = JSON.parse(_0x61dbb2),
        _0x159f0c =
          document.getElementById("Quantity-" + _0x51dce8) || document.getElementById("Drawer-quantity-" + _0x51dce8),
        _0x4dd83b = document.querySelectorAll(".cart-item");
      if (_0x261c24.errors) {
        (_0x159f0c.value = _0x159f0c.getAttribute("value")), this.updateLiveRegions(_0x51dce8, _0x261c24.errors);
        return;
      }
      if (!this.lineItemContainer) return;
      if (!_0x261c24.sections) {
        const _0x431c20 = await fetch(
          routes.cart_url +
            "?sections=" +
            this.getSectionsToRender()
              .map((_0x2bddfe) => _0x2bddfe.section)
              .join(","),
        );
        _0x261c24.sections = await _0x431c20.json();
      }
      this.classList.toggle("is-empty", _0x261c24.item_count === 0x0);
      const _0x4eb01a = document.querySelector("cart-drawer"),
        _0x26e59d = document.getElementById("main-cart-footer");
      if (_0x26e59d) _0x26e59d.classList.toggle("is-empty", _0x261c24.item_count === 0x0);
      if (_0x4eb01a) _0x4eb01a.classList.toggle("is-empty", _0x261c24.item_count === 0x0);
      this.getSectionsToRender().forEach((_0x2a13f7) => {
        const _0x4b88bf =
          document.getElementById(_0x2a13f7.id).querySelector(_0x2a13f7.selector) ||
          document.getElementById(_0x2a13f7.id);
        _0x4b88bf.innerHTML = this.getSectionInnerHTML(_0x261c24.sections[_0x2a13f7.section], _0x2a13f7.selector);
      });
      const _0x1bfe9c = _0x261c24.items[_0x51dce8 - 0x1] ? _0x261c24.items[_0x51dce8 - 0x1].quantity : undefined;
      let _0x213a6a = "";
      _0x4dd83b.length === _0x261c24.items.length &&
        _0x1bfe9c !== parseInt(_0x159f0c.value) &&
        (typeof _0x1bfe9c === "undefined"
          ? (_0x213a6a = window.cartStrings.error)
          : (_0x213a6a = window.cartStrings.quantityError.replace("[quantity]", _0x1bfe9c)));
      this.updateLiveRegions(_0x51dce8, _0x213a6a);
      const _0xe8e3cf =
        document.getElementById("CartItem-" + _0x51dce8) || document.getElementById("CartDrawer-Item-" + _0x51dce8);
      if (_0xe8e3cf && _0xe8e3cf.querySelector("[name=\x22" + _0x59bf09 + "\x22]"))
        _0x4eb01a
          ? trapFocus(_0x4eb01a, _0xe8e3cf.querySelector('[name="' + _0x59bf09 + "\x22]"))
          : _0xe8e3cf.querySelector('[name="' + _0x59bf09 + "\x22]").focus();
      else {
        if (_0x261c24.item_count === 0x0 && _0x4eb01a)
          trapFocus(_0x4eb01a.querySelector(".drawer__inner-empty"), _0x4eb01a.querySelector("a"));
        else
          document.querySelector(".cart-item") &&
            _0x4eb01a &&
            trapFocus(_0x4eb01a, document.querySelector(".cart-item__name"));
      }
      if (_0x4eb01a) {
        _0x4eb01a.checkForClear();
        const _0x36b443 = _0x4eb01a.querySelector("countdown-timer");
        if (_0x36b443) _0x36b443.playTimer();
        if (_0x4eb01a.querySelector("cart-drawer-gift")) {
          _0x4eb01a.checkForClear();
          let _0x562b99 = [],
            _0x286759 = [];
          _0x4eb01a.querySelectorAll("cart-drawer-gift").forEach((_0x379b05) => {
            _0x379b05.getUpdateRequired() &&
              (_0x4eb01a.querySelector(".cart-item--product-" + _0x379b05.dataset.handle)
                ? _0x379b05.dataset.selected === "false" && _0x286759.push(_0x379b05)
                : _0x379b05.dataset.selected === "true" && _0x562b99.push(_0x379b05));
          });
          if (_0x286759.length > 0x0) _0x286759[0x0].removeFromCart();
          else _0x562b99.length > 0x0 && _0x562b99[0x0].addToCart();
        }
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
      });
    } catch (_0x53c671) {
      this.querySelectorAll(".loading-overlay").forEach((_0x20a1fe) => _0x20a1fe.classList.add("hidden"));
      const _0x19798f = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      _0x19798f.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(_0x51dce8);
      if (this.secondCartItems && this.secondCartItems.updateCart) this.secondCartItems.updateCart();
      const _0x29cdeb = new CustomEvent("cartQuantityUpdated", {
        detail: {
          handle: "handle",
        },
      });
      document.dispatchEvent(_0x29cdeb);
    }
  }
  updateLiveRegions(_0x5eb0d9, _0x889d) {
    const _0x570f01 =
      document.getElementById("Line-item-error-" + _0x5eb0d9) ||
      document.getElementById("CartDrawer-LineItemError-" + _0x5eb0d9);
    if (_0x570f01) _0x570f01.querySelector(".cart-item__error-text").innerHTML = _0x889d;
    this.lineItemStatusElement.setAttribute("aria-hidden", !![]);
    const _0x5632aa =
      document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    _0x5632aa.setAttribute("aria-hidden", ![]),
      setTimeout(() => {
        _0x5632aa.setAttribute("aria-hidden", !![]);
      }, 0x3e8);
  }
  getSectionInnerHTML(_0x479fbe, _0x5b0c83) {
    return new DOMParser().parseFromString(_0x479fbe, "text/html").querySelector(_0x5b0c83).innerHTML;
  }
  enableLoading(_0x44e2b0) {
    const _0x442082 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x442082.classList.add("cart__items--disabled");
    const _0x9f779b = this.querySelectorAll("#CartItem-" + _0x44e2b0 + "\x20.loading-overlay"),
      _0x39cedb = this.querySelectorAll("#CartDrawer-Item-" + _0x44e2b0 + " .loading-overlay");
    [..._0x9f779b, ..._0x39cedb].forEach((_0x16ccaf) => _0x16ccaf.classList.remove("hidden")),
      document.activeElement.blur(),
      this.lineItemStatusElement.setAttribute("aria-hidden", ![]);
  }
  disableLoading(_0x4e7883) {
    const _0x2824af = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x2824af.classList.remove("cart__items--disabled");
    const _0x366102 = this.querySelectorAll("#CartItem-" + _0x4e7883 + " .loading-overlay"),
      _0x4b62d7 = this.querySelectorAll("#CartDrawer-Item-" + _0x4e7883 + "\x20.loading-overlay");
    _0x366102.forEach((_0xde67a0) => _0xde67a0.classList.add("hidden")),
      _0x4b62d7.forEach((_0x5b3131) => _0x5b3131.classList.add("hidden"));
  }
  clearCart() {
    const _0x57a15b = JSON.stringify({
      sections: this.getSectionsToRender().map((_0x50d3ac) => _0x50d3ac.section),
      sections_url: window.location.pathname,
    });
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        body: _0x57a15b,
      },
    })
      .then((_0x262708) => {
        return _0x262708.text();
      })
      .then((_0x5b84d2) => {
        const _0x513a6e = JSON.parse(_0x5b84d2);
        this.classList.add("is-empty");
        const _0x954306 = document.querySelector("cart-drawer"),
          _0x1ae03b = document.getElementById("main-cart-footer");
        if (_0x1ae03b) _0x1ae03b.classList.add("is-empty");
        if (_0x954306) _0x954306.classList.add("is-empty");
        this.getSectionsToRender().forEach((_0x34560) => {
          const _0x163441 =
            document.getElementById(_0x34560.id).querySelector(_0x34560.selector) ||
            document.getElementById(_0x34560.id);
          _0x163441.innerHTML = this.getSectionInnerHTML(_0x513a6e.sections[_0x34560.section], _0x34560.selector);
        }),
          _0x954306 && trapFocus(_0x954306.querySelector(".drawer__inner-empty"), _0x954306.querySelector("a")),
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "cart-items",
          });
      })
      ["catch"](() => {
        this.querySelectorAll(".loading-overlay").forEach((_0x545e47) => _0x545e47.classList.add("hidden"));
        const _0x503fee = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
        _0x503fee.textContent = window.cartStrings.error;
      });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
!customElements.get("cart-note") &&
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super(),
          this.addEventListener(
            "change",
            debounce((_0x2fa34f) => {
              const _0x5c52ae = JSON.stringify({
                note: _0x2fa34f.target.value,
              });
              fetch("" + routes.cart_update_url, {
                ...fetchConfig(),
                ...{
                  body: _0x5c52ae,
                },
              });
            }, ON_CHANGE_DEBOUNCE_TIMER),
          );
      }
    },
  );
function handleDiscountForm(_0x1907ee) {
  _0x1907ee.preventDefault();
  const _0x4d16a3 = _0x1907ee.target.querySelector("[name=cart-discount-field]"),
    _0x13a102 = _0x1907ee.target.querySelector(".cart-discount-form__error"),
    _0x4d118e = _0x4d16a3.value;
  if (_0x4d118e === undefined || _0x4d118e.length === 0x0) {
    _0x13a102.style.display = "block";
    return;
  }
  _0x13a102.style.display = "none";
  const _0x175b1e = "/checkout?discount=",
    _0x54195d = _0x175b1e + _0x4d118e;
  window.location.href = _0x54195d;
}
function handleDiscountFormChange(_0x84d277) {
  const _0x1a909e = document.querySelectorAll(".cart-discount-form__error");
  _0x1a909e.forEach((_0x563f18) => {
    _0x563f18.style.display = "none";
  });
}

class SearchForm extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector('input[type="search"]')),
      (this.resetButton = this.querySelector("button[type=\x22reset\x22]"));
    if (this.dataset.main === "false");
    this.input &&
      (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
      this.input.addEventListener(
        "input",
        debounce((_0x590986) => {
          this.onChange(_0x590986);
        }, 0x12c).bind(this),
      ));
  }
  toggleResetButton() {
    const _0x48a967 = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0x0 && _0x48a967) this.resetButton.classList.remove("hidden");
    else this.input.value.length === 0x0 && !_0x48a967 && this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }
  onFormReset(_0x1d4ebb) {
    _0x1d4ebb.preventDefault(),
      this.shouldResetForm() && ((this.input.value = ""), this.input.focus(), this.toggleResetButton());
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super(),
      (this.cachedResults = {}),
      (this.predictiveSearchResults = this.querySelector("[data-predictive-search]")),
      (this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search")),
      (this.isOpen = ![]),
      (this.abortController = new AbortController()),
      (this.searchTerm = ""),
      this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
      this.input.addEventListener("focus", this.onFocus.bind(this)),
      this.addEventListener("focusout", this.onFocusOut.bind(this)),
      this.addEventListener("keyup", this.onKeyup.bind(this)),
      this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const _0x24fb40 = this.getQuery();
    (!this.searchTerm || !_0x24fb40.startsWith(this.searchTerm)) &&
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    this.updateSearchForTerm(this.searchTerm, _0x24fb40), (this.searchTerm = _0x24fb40);
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(_0x4328bb) {
    if (!this.getQuery().length || this.querySelector("[aria-selected=\x22true\x22]\x20a")) _0x4328bb.preventDefault();
  }
  onFormReset(_0x5a986b) {
    super.onFormReset(_0x5a986b),
      super.shouldResetForm() &&
        ((this.searchTerm = ""),
        this.abortController.abort(),
        (this.abortController = new AbortController()),
        this.closeResults(true));
  }
  onFocus() {
    const _0x29f55c = this.getQuery();
    if (!_0x29f55c.length) return;
    if (this.searchTerm !== _0x29f55c) this.onChange();
    else this.getAttribute("results") === "true" ? this.open() : this.getSearchResults(this.searchTerm);
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  onKeyup(_0x111af1) {
    if (!this.getQuery().length) this.close(true);
    _0x111af1.preventDefault();
    switch (_0x111af1.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(_0x175118) {
    (_0x175118.code === "ArrowUp" || _0x175118.code === "ArrowDown") && _0x175118.preventDefault();
  }
  updateSearchForTerm(_0x5cc73c, _0x5c8f88) {
    const _0x47c920 = this.querySelector("[data-predictive-search-search-for-text]"),
      _0x180f92 = _0x47c920?.innerText;
    if (_0x180f92) {
      if (_0x180f92.match(new RegExp(_0x5cc73c, "g")).length > 0x1) return;
      const _0x207a84 = _0x180f92.replace(_0x5cc73c, _0x5c8f88);
      _0x47c920.innerText = _0x207a84;
    }
  }
  switchOption(_0x12bf4c) {
    if (!this.getAttribute("open")) return;
    const _0x512437 = _0x12bf4c === "up",
      _0x2ee56d = this.querySelector("[aria-selected=\x22true\x22]"),
      _0x20b080 = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(
        (_0x41aa2b) => _0x41aa2b.offsetParent !== null,
      );
    let _0x28cfec = 0x0;
    if (_0x512437 && !_0x2ee56d) return;
    let _0x1b26b6 = -0x1,
      _0x3fac6a = 0x0;
    while (_0x1b26b6 === -0x1 && _0x3fac6a <= _0x20b080.length) {
      _0x20b080[_0x3fac6a] === _0x2ee56d && (_0x1b26b6 = _0x3fac6a), _0x3fac6a++;
    }
    this.statusElement.textContent = "";
    if (!_0x512437 && _0x2ee56d) _0x28cfec = _0x1b26b6 === _0x20b080.length - 0x1 ? 0x0 : _0x1b26b6 + 0x1;
    else _0x512437 && (_0x28cfec = _0x1b26b6 === 0x0 ? _0x20b080.length - 0x1 : _0x1b26b6 - 0x1);
    if (_0x28cfec === _0x1b26b6) return;
    const _0x125fa4 = _0x20b080[_0x28cfec];
    _0x125fa4.setAttribute("aria-selected", true);
    if (_0x2ee56d) _0x2ee56d.setAttribute("aria-selected", ![]);
    this.input.setAttribute("aria-activedescendant", _0x125fa4.id);
  }
  selectOption() {
    const _0x35f5e4 = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (_0x35f5e4) _0x35f5e4.click();
  }
  getSearchResults(_0x166c64) {
    const _0x528b2b = _0x166c64.replace("\x20", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[_0x528b2b]) {
      this.renderSearchResults(this.cachedResults[_0x528b2b]);
      return;
    }
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(_0x166c64) + "&section_id=predictive-search", {
      signal: this.abortController.signal,
    })
      .then((_0x45e732) => {
        if (!_0x45e732.ok) {
          var _0x51158b = new Error(_0x45e732.status);
          this.close();
          throw _0x51158b;
        }
        return _0x45e732.text();
      })
      .then((_0x295a12) => {
        const _0x3cbed9 = new DOMParser()
          .parseFromString(_0x295a12, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.allPredictiveSearchInstances.forEach((_0x31de7e) => {
          _0x31de7e.cachedResults[_0x528b2b] = _0x3cbed9;
        }),
          this.renderSearchResults(_0x3cbed9);
      })
      ["catch"]((_0x15a72b) => {
        if (_0x15a72b?.code === 0x14) return;
        this.close();
        throw _0x15a72b;
      });
  }
  setLiveRegionLoadingState() {
    (this.statusElement = this.statusElement || this.querySelector(".predictive-search-status")),
      (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
      this.setLiveRegionText(this.loadingText),
      this.setAttribute("loading", true);
  }
  setLiveRegionText(_0x53e5e8) {
    this.statusElement.setAttribute("aria-hidden", "false"),
      (this.statusElement.textContent = _0x53e5e8),
      setTimeout(() => {
        this.statusElement.setAttribute("aria-hidden", "true");
      }, 0x3e8);
  }
  renderSearchResults(_0x73c883) {
    (this.predictiveSearchResults.innerHTML = _0x73c883),
      this.setAttribute("results", true),
      this.setLiveRegionResults(),
      this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading"),
      this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  getResultsMaxHeight() {
    return (
      (this.resultsMaxHeight =
        window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom),
      this.resultsMaxHeight
    );
  }
  open() {
    (this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px"),
      this.setAttribute("open", true),
      this.input.setAttribute("aria-expanded", true),
      (this.isOpen = true);
  }
  close(_0x1a2eb7 = ![]) {
    this.closeResults(_0x1a2eb7), (this.isOpen = ![]);
  }
  closeResults(_0x749560 = ![]) {
    _0x749560 && ((this.input.value = ""), this.removeAttribute("results"));
    const _0x4c089d = this.querySelector('[aria-selected="true"]');
    if (_0x4c089d) _0x4c089d.setAttribute("aria-selected", ![]);
    this.input.setAttribute("aria-activedescendant", ""),
      this.removeAttribute("loading"),
      this.removeAttribute("open"),
      this.input.setAttribute("aria-expanded", ![]),
      (this.resultsMaxHeight = ![]),
      this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "dat" + "a-def" + "er";
class CartDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.upsellHandles = this.getUpsellHandles()),
      this.checkForClear(),
      this.addEventListener("keyup", (_0x35b222) => _0x35b222.code === "Escape" && this.close()),
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)),
      this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const _0x23f24c = document.querySelector("#cart-icon-bubble"),
      _0xeaa89 = _0x23f24c.closest(".header__icons");
    _0x23f24c.setAttribute("role", "button"),
      _0x23f24c.setAttribute("aria-haspopup", "dialog"),
      _0x23f24c.addEventListener("click", (_0x3b172d) => {
        _0x3b172d.preventDefault(), this.open(_0x23f24c);
      }),
      (this.oseid = _0xeaa89.querySelector("form").dataset[this.dataset.type]),
      _0x23f24c.addEventListener("keydown", (_0x384569) => {
        _0x384569.code.toUpperCase() === "SPACE" && (_0x384569.preventDefault(), this.open(_0x23f24c));
      });
  }
  open(_0x354122) {
    if (_0x354122) this.setActiveElement(_0x354122);
    const _0x18dbec = this.querySelector('[id^="Details-"] summary');
    if (_0x18dbec && !_0x18dbec.hasAttribute("role")) this.setSummaryAccessibility(_0x18dbec);
    setTimeout(() => {
      this.classList.add("animate", "active");
    }),
      this.addEventListener(
        "transitionend",
        () => {
          const _0x5d4906 = this.classList.contains("is-empty")
              ? this.querySelector(".drawer__inner-empty")
              : document.getElementById("CartDrawer"),
            _0x53dcba = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
          trapFocus(_0x5d4906, _0x53dcba);
        },
        {
          once: true,
        },
      ),
      document.body.classList.add("overflow-hidden");
    const _0x50a004 = this.querySelector("countdown-timer");
    if (_0x50a004) _0x50a004.playTimer();
  }
  close() {
    this.classList.remove("active"),
      removeTrapFocus(this.activeElement),
      document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const _0x3f4c9 = this.querySelectorAll("cart-drawer-upsell[data-toggle=\x22true\x22],\x20cart-drawer-gift"),
      _0xb1bdee = [];
    return (
      _0x3f4c9.forEach((_0x6852d6) => {
        _0x6852d6.dataset.handle && _0xb1bdee.push(_0x6852d6.dataset.handle);
      }),
      _0xb1bdee
    );
  }
  oneNonUpellRemaining() {
    const _0x34b5d6 = this.querySelectorAll(".cart-item");
    let _0x5ca33a = 0x0;
    return (
      _0x34b5d6.forEach((_0x307e9a) => {
        this.upsellHandles.forEach((_0x112bdf) => {
          _0x307e9a.classList.contains("cart-item--product-" + _0x112bdf) && _0x5ca33a++;
        });
      }),
      _0x34b5d6.length - _0x5ca33a <= 0x1
    );
  }
  checkForClear() {
    const _0x51dbfd = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach((_0x528949) => {
      _0x51dbfd ? (_0x528949.clearCart = true) : (_0x528949.clearCart = ![]);
    });
  }
  setSummaryAccessibility(_0x310ed3) {
    _0x310ed3.setAttribute("role", "button"),
      _0x310ed3.setAttribute("aria-expanded", "false"),
      _0x310ed3.nextElementSibling.getAttribute("id") &&
        _0x310ed3.setAttribute("aria-controls", _0x310ed3.nextElementSibling.id),
      _0x310ed3.addEventListener("click", (_0x45a8ba) => {
        _0x45a8ba.currentTarget.setAttribute(
          "aria-expanded",
          !_0x45a8ba.currentTarget.closest("details").hasAttribute("open"),
        );
      }),
      _0x310ed3.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(_0x10a603, _0x1ec4bd = ![]) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty"),
      (this.productId = _0x10a603.id),
      this.getSectionsToRender().forEach((_0x3cfe78) => {
        const _0x3dad6b = _0x3cfe78.selector
          ? document.querySelector(_0x3cfe78.selector)
          : document.getElementById(_0x3cfe78.id);
        if (_0x3dad6b)
          _0x3dad6b.innerHTML = this.getSectionInnerHTML(_0x10a603.sections[_0x3cfe78.id], _0x3cfe78.selector);
      }),
      this.checkForClear();
    const _0x3138a0 = this.querySelector("countdown-timer");
    if (_0x3138a0 && _0x3138a0.playTimer) _0x3138a0.playTimer();
    let _0x367232 = [],
      _0x48e797 = [];
    this.querySelectorAll("cart-drawer-gift").forEach((_0x554e9e) => {
      _0x554e9e.getUpdateRequired() &&
        (this.querySelector(".cart-item--product-" + _0x554e9e.dataset.handle)
          ? _0x554e9e.dataset.selected === "false" && _0x48e797.push(_0x554e9e)
          : _0x554e9e.dataset.selected === "true" && _0x367232.push(_0x554e9e));
    });
    if (_0x48e797.length > 0x0) _0x48e797[0x0].removeFromCart();
    else _0x367232.length > 0x0 && _0x367232[0x0].addToCart();
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (_0x1ec4bd) return;
      this.open();
    });
  }
  getSectionInnerHTML(_0x9d1292, _0xd15ce8 = ".shopify-section") {
    let _0x3924cb = new DOMParser().parseFromString(_0x9d1292, "text/html").querySelector(_0xd15ce8);
    _0xd15ce8 === "#CartDrawer" && fixParsedHtml(this, _0x3924cb);
    let _0x232d50 = _0x3924cb.innerHTML;
    return _0x232d50;
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }
  getSectionDOM(_0x24d259, _0x328298 = ".shopify-section") {
    return new DOMParser().parseFromString(_0x24d259, "text/html").querySelector(_0x328298);
  }
  setActiveElement(_0x27a92c) {
    this.activeElement = _0x27a92c;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super(),
      (this.cartDrawer = document.querySelector("cart-drawer")),
      (this.secondCartItems = document.querySelector("cart-items"));
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname,
      }),
    })
      .then((_0x550521) => _0x550521.json())
      .then((_0x4e489e) => {
        document.querySelector("cart-drawer").renderContents(_0x4e489e, true);
      })
      ["catch"]((_0x1e919b) => {
        console.error(_0x1e919b);
      });
  }
  getSectionInnerHTML(_0x50ec55, _0x425a5c) {
    let _0x19e7bb = new DOMParser().parseFromString(_0x50ec55, "text/html").querySelector(_0x425a5c);
    _0x425a5c === ".drawer__inner" && fixParsedHtml(this.cartDrawer, _0x19e7bb);
    let _0x1a5ef8 = _0x19e7bb.innerHTML;
    return _0x1a5ef8;
  }
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(_0x560b6c, _0x545140) {
  const _0x22f9d4 = _0x545140.querySelector(".cart-timer");
  if (_0x22f9d4) {
    oldTimer = _0x560b6c.querySelector(".cart-timer");
    if (oldTimer) _0x22f9d4.innerHTML = oldTimer.innerHTML;
  }
  const _0x4b2ac8 = _0x560b6c.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
  let _0x1e47a5 = _0x545140.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
  _0x4b2ac8.forEach((_0x1fc7b0, _0x2a6a3a) => {
    if (_0x1fc7b0.nodeName.toLowerCase() === "cart-drawer-upsell")
      _0x1e47a5[_0x2a6a3a].dataset.selected = _0x1fc7b0.dataset.selected;
    (_0x1e47a5[_0x2a6a3a].dataset.id = _0x1fc7b0.dataset.id),
      (_0x1e47a5[_0x2a6a3a].querySelector('[name="id"]').value = _0x1fc7b0.querySelector('[name="id"]').value);
    if (_0x1e47a5[_0x2a6a3a].querySelector(".upsell__image__img"))
      _0x1e47a5[_0x2a6a3a].querySelector(".upsell__image__img").src =
        _0x1fc7b0.querySelector(".upsell__image__img").src;
    if (_0x1e47a5[_0x2a6a3a].querySelector(".upsell__variant-picker")) {
      const _0x22deb6 = _0x1fc7b0.querySelectorAll(".select__select");
      _0x1e47a5[_0x2a6a3a].querySelectorAll(".select__select").forEach((_0x294ad3, _0x4f9e94) => {
        (_0x294ad3.value = _0x22deb6[_0x4f9e94].value),
          _0x294ad3.querySelectorAll("option").forEach((_0x2292c4) => {
            _0x2292c4.removeAttribute("selected");
            if (_0x2292c4.value === _0x22deb6[_0x4f9e94].value.trim()) _0x2292c4.setAttribute("selected", "");
          });
      });
    }
    if (_0x1fc7b0.dataset.updatePrices === "true") {
      var _0x57bb04 = _0x1e47a5[_0x2a6a3a].querySelector(".upsell__price"),
        _0x1265a6 = _0x1fc7b0.querySelector(".upsell__price");
      if (_0x57bb04 && _0x1265a6) _0x57bb04.innerHTML = _0x1265a6.innerHTML;
    }
  });
}
!customElements.get("product-form") &&
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super(),
          (this.form = this.querySelector("form")),
          this.form.addEventListener("submit", this.handleSubmit.bind(this)),
          (this.formIdInput = this.form.querySelector("[name=id]")),
          (this.formIdInput.disabled = ![]),
          (this.isMain = this.classList.contains("main-product-form")),
          (this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : []),
          (this.skipCart = this.formIdInput.dataset.skipCart === "true"),
          (this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification")),
          (this.isCartUpsell = this.dataset.isCartUpsell === "true"),
          (this.submitButton = this.querySelector("[type=\x22submit\x22]")),
          document.querySelector("cart-drawer") &&
            (this.submitButton.setAttribute("aria-haspopup", "dialog"), (this.hasDrawer = true)),
          (this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner")),
          (this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section)),
          (this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section)),
          (this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section)),
          (this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section)),
          (this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section)),
          (this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']")),
          (this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section)),
          (this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section)),
          (this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section)),
          (this.variantInputs = this.form.querySelector(".product-form__variants"));
      }
      handleSubmit(_0x38ab15) {
        console.log("REF === ", this.ref);
        this.ref = false;

        let _0x1b3097 = null,
          _0x2f37ab = ![];
        _0x38ab15 &&
          (_0x38ab15.preventDefault(),
          _0x38ab15.currentTarget.classList.contains("button--has-spinner") &&
            ((_0x1b3097 = _0x38ab15.currentTarget), _0x1b3097.classList.add("loading")),
          _0x38ab15.currentTarget.dataset.skipCartButton === "true" && (_0x2f37ab = true));
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", true);
        if (!_0x1b3097) {
          this.submitButton.classList.add("loading");
          if (this.loadingSpinner) this.loadingSpinner.classList.remove("hidden");
        }
        this.additionalAtcButtons.forEach((_0x32fdc8) => {
          _0x32fdc8.setAttribute("disabled", "");
        });
        this.displayedSubmitButton &&
          (this.displayedSubmitButton.setAttribute("disabled", ""),
          this.displayedSubmitButton.classList.add("loading"));
        let _0xc622af = ![];
        if (this.variantInputs && !this.ref) {
          this.variantInputs.innerHTML = "";
          let _0x41b18c = "",
            _0x4be9f0 = [];
          this.hasDrawer &&
            !this.isCartUpsell &&
            !this.skipCart &&
            this.cart
              .querySelectorAll("cart-drawer-upsell[data-toggle=\x22true\x22],\x20cart-drawer-gift")
              .forEach((_0x38c304) => {
                _0x38c304.dataset.selected === "true" &&
                  !this.cart.querySelector(".cart-item--product-" + _0x38c304.dataset.handle) &&
                  _0x4be9f0.unshift(_0x38c304.dataset.id);
              });
          if (this.bundleDeals) {
            _0xc622af = true;
            this.dataset.includePdpUpsells === "true" &&
              document.querySelectorAll("product-info-upsell").forEach((_0x39a394) => {
                if (_0x39a394.dataset.selected === "true") _0x4be9f0.unshift(_0x39a394.dataset.id);
              });
            for (let _0x48b130 = 0x0; _0x48b130 < _0x4be9f0.length; _0x48b130++) {
              _0x41b18c +=
                '<input type="hidden" name="items[' +
                _0x48b130 +
                '][quantity]" value="1"><input type="hidden" name="items[' +
                _0x48b130 +
                "][id]\x22\x20value=\x22" +
                _0x4be9f0[_0x48b130] +
                "\x22>";
            }
            let _0x310de0 = _0x4be9f0.length;
            for (let _0x77f3e2 = 0x0; _0x77f3e2 < this.bundleDeals.formVariants.length; _0x77f3e2++) {
              const _0xd15a82 = this.bundleDeals.formVariants[_0x77f3e2];
              _0x41b18c +=
                '<input type="hidden" name="items[' +
                (_0x77f3e2 + _0x310de0) +
                '][quantity]" value="' +
                _0xd15a82.quantity +
                '"><input type="hidden" name="items[' +
                (_0x77f3e2 + _0x310de0) +
                "][id]\x22\x20value=\x22" +
                _0xd15a82.id +
                "\x22>";
            }
            this.variantInputs.innerHTML = _0x41b18c;
          } else {
            let _0x457834 = [];
            this.quantityGifts &&
              this.quantityGifts.unlockedItems.length > 0x0 &&
              (_0x4be9f0 = [..._0x4be9f0, ...this.quantityGifts.unlockedItems]);
            for (let _0x3c2dc9 = this.upsells.length - 0x1; _0x3c2dc9 >= 0x0; _0x3c2dc9--) {
              this.upsells[_0x3c2dc9].dataset.selected === "true" && _0x4be9f0.push(this.upsells[_0x3c2dc9].dataset.id);
            }
            if (this.mainBundleItems.length === 0x0) {
              if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0x0)
                (_0x4be9f0 = [..._0x4be9f0, ...this.quantityBreaks.formVariants]),
                  (_0x457834 = [...this.quantityBreaks.formVariants]);
              else {
                if (
                  _0x4be9f0.length > 0x0 &&
                  (!this.quantityBreaks || this.quantityBreaks.formVariants.length === 0x0)
                ) {
                  let _0x4bb948 = 0x1;
                  if (this.quantityBreaks) _0x4bb948 = this.quantityBreaks.selectedQuantity;
                  else
                    this.quantityPicker &&
                      (_0x4bb948 = parseInt(this.quantityPicker.querySelector(".quantity__input").value));
                  for (let _0x15d801 = 0x0; _0x15d801 < _0x4bb948; _0x15d801++) {
                    _0x4be9f0.push(this.formIdInput.value);
                  }
                  _0x457834 = [this.formIdInput.value];
                }
              }
            }
            for (let _0x4cf4b9 = this.mainBundleItems.length - 0x1; _0x4cf4b9 >= 0x0; _0x4cf4b9--) {
              _0x4be9f0.push(this.mainBundleItems[_0x4cf4b9].dataset.id),
                _0x457834.push(this.mainBundleItems[_0x4cf4b9].dataset.id);
            }
            if (_0x4be9f0.length > 0x0) {
              _0xc622af = true;
              const _0x4426bc = [];
              for (let _0x172fd5 = 0x0; _0x172fd5 < _0x4be9f0.length; _0x172fd5++) {
                const _0x464aa8 = _0x4be9f0[_0x172fd5],
                  _0xd1458 = _0x4426bc.findIndex((_0x5a2b91) => _0x5a2b91.id === _0x464aa8);
                _0xd1458 < 0x0
                  ? _0x4426bc.push({
                      id: _0x464aa8,
                      quantity: 0x1,
                    })
                  : (_0x4426bc[_0xd1458].quantity += 0x1);
              }
              let _0x1e56ad = [];
              this.customFields.forEach((_0xd7e263) => {
                _0xd7e263.dataset.disabled != "true" &&
                  _0x1e56ad.push({
                    fieldName: _0xd7e263.fieldName,
                    value: _0xd7e263.prevValue,
                  });
              });
              this.classList.contains("main-product-form") &&
                ((this.sellingPlanInput =
                  this.querySelector('.appstle-active-option [name="selling_plan"]') ||
                  this.querySelector('[name="selling_plan"]') ||
                  document.querySelector('.sls-purchase [name="selling_plan"]')),
                (this.simpleBundlesContainer = this.querySelector("#simple-bundles-io-options")),
                (this.appPropertyInputs = document.querySelectorAll(
                  ".cl-upload--wrapper\x20input[name^=\x22properties[\x22],\x20.uploadkit-attribute-container\x20input[name^=\x22properties[\x22],\x20.gpo-hidden-inputs\x20input:not(#validator)",
                )));
              for (let _0x34b964 = 0x0; _0x34b964 < _0x4426bc.length; _0x34b964++) {
                const _0x3c8011 = _0x4426bc[_0x34b964];
                (_0x41b18c +=
                  '<input type="hidden" name="items[' +
                  _0x34b964 +
                  '][quantity]" value="' +
                  _0x3c8011.quantity +
                  '"><input type="hidden" name="items[' +
                  _0x34b964 +
                  '][id]" value="' +
                  _0x3c8011.id +
                  "\x22>"),
                  _0x457834.includes(_0x3c8011.id) &&
                    (_0x1e56ad.forEach((_0x577a4a) => {
                      _0x41b18c +=
                        '<input type="hidden" name="items[' +
                        _0x34b964 +
                        "][properties][" +
                        _0x577a4a.fieldName +
                        "]\x22\x20value=\x22" +
                        _0x577a4a.value +
                        "\x22>";
                    }),
                    this.sellingPlanInput &&
                      typeof this.sellingPlanInput.value === "string" &&
                      this.sellingPlanInput.value.length > 0x0 &&
                      (_0x41b18c +=
                        '<input type="hidden" name="items[' +
                        _0x34b964 +
                        '][selling_plan]" value="' +
                        this.sellingPlanInput.value +
                        "\x22>"),
                    this.simpleBundlesContainer &&
                      this.simpleBundlesContainer.querySelectorAll("select").forEach((_0x12eb8b) => {
                        const _0x16101c = input.name.match(/properties\[(.*?)\]/);
                        if (_0x16101c) {
                          let _0x310dda = _0x16101c[0x1];
                          _0x41b18c +=
                            "<input\x20type=\x22hidden\x22\x20name=\x22items[" +
                            _0x34b964 +
                            "][properties][" +
                            _0x310dda +
                            "]\x22\x20value=\x22" +
                            input.value +
                            "\x22>";
                        }
                      }),
                    this.appPropertyInputs.forEach((_0x41509e) => {
                      let _0x298883 = _0x41509e.name.match(/properties\[(.*?)\]/)[0x1];
                      _0x41b18c +=
                        '<input type="hidden" name="items[' +
                        _0x34b964 +
                        "][properties][" +
                        _0x298883 +
                        "]\x22\x20value=\x22" +
                        _0x41509e.value +
                        "\x22>";
                    }));
              }
              this.variantInputs.innerHTML = _0x41b18c;
            }
          }
        }
        var _0x491cb8 = fetchConfig("javascript");
        (_0x491cb8.headers["X-Requested-With"] = "XMLHttpRequest"), delete _0x491cb8.headers["Content-Type"];
        var _0x3a396c = new FormData(this.form);
        if (this.ref) _0xc622af = true;
        this.cart &&
          (_0x3a396c.append(
            "sections",
            this.cart.getSectionsToRender().map((_0x486139) => _0x486139.id),
          ),
          _0x3a396c.append("sections_url", window.location.pathname),
          this.cart.setActiveElement(document.activeElement));
        if (_0xc622af) {
          const _0xa8bd0f = this.dataset.options ? this.dataset.options.split(",") : [],
            _0xd5bce0 = ["id", "quantity", ..._0xa8bd0f];
          for (let _0x60b3e4 = 0x0; _0x60b3e4 < _0xd5bce0.length; _0x60b3e4++) {
            _0x3a396c["delete"](_0xd5bce0[_0x60b3e4]);
          }
        }
        (_0x491cb8.body = _0x3a396c),
          fetch("" + routes.cart_add_url, _0x491cb8)
            .then((_0x37d847) => _0x37d847.json())
            .then((_0x5a52bf) => {
              if (_0x5a52bf.status) {
                this.handleErrorMessage(_0x5a52bf.description);
                const _0x515fb2 = this.submitButton.querySelector(".sold-out-message");
                if (!_0x515fb2) return;
                this.submitButton.setAttribute("aria-disabled", true),
                  this.submitButton.querySelector("span").classList.add("hidden"),
                  _0x515fb2.classList.remove("hidden"),
                  (this.error = true);
                return;
              } else {
                if (this.skipCart || _0x2f37ab) {
                  window.location = "/checkout";
                  return;
                } else {
                  if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }
                }
              }
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                });
              this.error = ![];
              const _0x438afe = this.closest("quick-add-modal");
              _0x438afe
                ? (document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(_0x5a52bf, this.isCartUpsell);
                      });
                    },
                    {
                      once: true,
                    },
                  ),
                  _0x438afe.hide(true))
                : this.cart.renderContents(_0x5a52bf, this.isCartUpsell);
            })
            ["catch"]((_0x17bd96) => {
              console.error(_0x17bd96);
            })
            ["finally"](() => {
              if (_0x1b3097) _0x1b3097.classList.remove("loading");
              else {
                this.submitButton.classList.remove("loading");
                if (this.loadingSpinner) this.loadingSpinner.classList.add("hidden");
              }
              this.additionalAtcButtons.forEach((_0x446020) => {
                _0x446020.removeAttribute("disabled");
              });
              this.displayedSubmitButton &&
                (this.displayedSubmitButton.removeAttribute("disabled"),
                this.displayedSubmitButton.classList.remove("loading"));
              if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
              if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            });
      }
      handleErrorMessage(_0x3d814f = ![]) {
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        (this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
          this.errorMessageWrapper.toggleAttribute("hidden", !_0x3d814f),
          _0x3d814f && (this.errorMessage.textContent = _0x3d814f);
      }
    },
  );
!customElements.get("product-info") &&
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super(),
          (this.deferredMedia = document.querySelector("[" + defMed + "]")),
          (this.input = this.querySelector(".quantity__input")),
          (this.currentVariant = this.querySelector(".product-variant-id")),
          (this.variantSelects = this.querySelector("variant-radios")),
          (this.submitButton = this.querySelector("[type=\x22submit\x22]")),
          (this.form = this.querySelector("#ProductForm-" + this.dataset.section)),
          (this.hasUrl = this.dataset.url !== null);
      }
      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        !this.dataset.originalSection &&
          (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this)));
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (_0x2ca8ed) => {
          const _0x56fe96 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (_0x2ca8ed.data.sectionId !== _0x56fe96) return;
          this.updateQuantityRules(_0x2ca8ed.data.sectionId, _0x2ca8ed.data.html), this.setQuantityBoundries();
        });
        if (!this.form) return;
        if (!this.deferredMedia || !this.deferredMedia.src || !this.deferredMedia.src.includes("net"))
          this.form.ref = true;
      }
      disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(),
          this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
      }
      setQuantityBoundries() {
        const _0xa5c9cc = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0x0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 0x1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 0x1,
        };
        let _0x595a54 = _0xa5c9cc.min;
        const _0x281630 = _0xa5c9cc.max === null ? _0xa5c9cc.max : _0xa5c9cc.max - _0xa5c9cc.cartQuantity;
        if (_0x281630 !== null) _0x595a54 = Math.min(_0x595a54, _0x281630);
        if (_0xa5c9cc.cartQuantity >= _0xa5c9cc.min) _0x595a54 = Math.min(_0x595a54, _0xa5c9cc.step);
        (this.input.min = _0x595a54),
          (this.input.max = _0x281630),
          (this.input.value = _0x595a54),
          publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }
      initShareLinks() {
        const _0x4beaa1 = this.querySelector(".share-url-button");
        if (!_0x4beaa1) this.shareUrl = true;
      }
      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden"),
          fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section)
            .then((_0x4f37e4) => {
              return _0x4f37e4.text();
            })
            .then((_0x3c000b) => {
              const _0x2423d9 = new DOMParser().parseFromString(_0x3c000b, "text/html");
              this.updateQuantityRules(this.dataset.section, _0x2423d9), this.setQuantityBoundries();
            })
            ["catch"]((_0x9eda2c) => {
              console.error(_0x9eda2c);
            })
            ["finally"](() => {
              this.querySelector(".quantity__rules-cart\x20.loading-overlay").classList.add("hidden");
            });
      }
      updateQuantityRules(_0x528603, _0x5498c7) {
        const _0x1de91f = _0x5498c7.getElementById("Quantity-Form-" + _0x528603),
          _0x6b73e9 = [".quantity__input", ".quantity__rules", ".quantity__label"];
        for (let _0xb99d of _0x6b73e9) {
          const _0x16192c = this.quantityForm.querySelector(_0xb99d),
            _0x48eec5 = _0x1de91f.querySelector(_0xb99d);
          if (!_0x16192c || !_0x48eec5) continue;
          if (_0xb99d === ".quantity__input") {
            const _0x33bb6b = ["data-cart-quantity", "data-min", "data-max", "step"];
            for (let _0x4ce27f of _0x33bb6b) {
              const _0x29a80d = _0x48eec5.getAttribute(_0x4ce27f);
              if (_0x29a80d !== null) _0x16192c.setAttribute(_0x4ce27f, _0x29a80d);
            }
          } else _0x16192c.innerHTML = _0x48eec5.innerHTML;
        }
      }
    },
  );
function getFocusableElements(_0x323718) {
  return Array.from(
    _0x323718.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
document.querySelectorAll('[id^="Details-"] summary').forEach((_0x2ad9ce) => {
  _0x2ad9ce.setAttribute("role", "button"),
    _0x2ad9ce.setAttribute("aria-expanded", _0x2ad9ce.parentNode.hasAttribute("open"));
  _0x2ad9ce.nextElementSibling.getAttribute("id") &&
    _0x2ad9ce.setAttribute("aria-controls", _0x2ad9ce.nextElementSibling.id);
  _0x2ad9ce.addEventListener("click", (_0x1cb1d3) => {
    _0x1cb1d3.currentTarget.setAttribute(
      "aria-expanded",
      !_0x1cb1d3.currentTarget.closest("details").hasAttribute("open"),
    );
  });
  if (_0x2ad9ce.closest("header-drawer")) return;
  _0x2ad9ce.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(_0x498069, _0x172d06 = _0x498069) {
  var _0x4636f2 = getFocusableElements(_0x498069),
    _0x4e47cb = _0x4636f2[0x0],
    _0x4b8f8c = _0x4636f2[_0x4636f2.length - 0x1];
  removeTrapFocus(),
    (trapFocusHandlers.focusin = (_0x56562e) => {
      if (_0x56562e.target !== _0x498069 && _0x56562e.target !== _0x4b8f8c && _0x56562e.target !== _0x4e47cb) return;
      document.addEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (_0x43ebf1) {
      if (_0x43ebf1.code.toUpperCase() !== "TAB") return;
      _0x43ebf1.target === _0x4b8f8c && !_0x43ebf1.shiftKey && (_0x43ebf1.preventDefault(), _0x4e47cb.focus()),
        (_0x43ebf1.target === _0x498069 || _0x43ebf1.target === _0x4e47cb) &&
          _0x43ebf1.shiftKey &&
          (_0x43ebf1.preventDefault(), _0x4b8f8c.focus());
    }),
    document.addEventListener("focusout", trapFocusHandlers.focusout),
    document.addEventListener("focusin", trapFocusHandlers.focusin),
    _0x172d06.focus(),
    _0x172d06.tagName === "INPUT" &&
      ["search", "text", "email", "url"].includes(_0x172d06.type) &&
      _0x172d06.value &&
      _0x172d06.setSelectionRange(0x0, _0x172d06.value.length);
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((_0x5aa9f9) => {
    _0x5aa9f9.contentWindow.postMessage(
      "{\x22event\x22:\x22command\x22,\x22func\x22:\x22" + "pauseVideo" + "\x22,\x22args\x22:\x22\x22}",
      "*",
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((_0x3e72c3) => {
      _0x3e72c3.contentWindow.postMessage("{\x22method\x22:\x22pause\x22}", "*");
    }),
    document.querySelectorAll("media-gallery template video").forEach((_0x6ae868) => _0x6ae868.pause()),
    document.querySelectorAll("product-model").forEach((_0x512c27) => {
      if (_0x512c27.modelViewerUI) _0x512c27.modelViewerUI.pause();
    });
}

function removeTrapFocus(_0x2e01a5 = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin),
    document.removeEventListener("focusout", trapFocusHandlers.focusout),
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (_0x2e01a5) _0x2e01a5.focus();
}
function onKeyUpEscape(_0x2c88cd) {
  if (_0x2c88cd.code.toUpperCase() !== "ESCAPE") return;
  const _0x3aa1c0 = _0x2c88cd.target.closest("details[open]");
  if (!_0x3aa1c0) return;
  const _0x73bdf9 = _0x3aa1c0.querySelector("summary");
  _0x3aa1c0.removeAttribute("open"), _0x73bdf9.setAttribute("aria-expanded", ![]), _0x73bdf9.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", {
        bubbles: true,
      })),
      (this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section)),
      this.input.addEventListener("change", this.onInputChange.bind(this)),
      this.querySelectorAll("button").forEach((_0x5dade9) =>
        _0x5dade9.addEventListener("click", this.onButtonClick.bind(this)),
      );
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules(),
      (this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this)));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(_0x22defb) {
    this.validateQtyRules();
  }
  onButtonClick(_0x4b190e) {
    _0x4b190e.preventDefault();
    const _0x188684 = this.input.value;
    _0x4b190e.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (_0x188684 !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const _0x2e4e96 = parseInt(this.input.value);
    if (this.input.min) {
      const _0xe8d8ca = parseInt(this.input.min),
        _0x55ba65 = this.querySelector(".quantity__button[name='minus']");
      _0x55ba65.classList.toggle("disabled", _0x2e4e96 <= _0xe8d8ca);
    }
    if (this.input.max) {
      const _0x199495 = parseInt(this.input.max),
        _0x77f65a = this.querySelector(".quantity__button[name='plus']");
      _0x77f65a.classList.toggle("disabled", _0x2e4e96 >= _0x199495);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) this.quantityGifts.unlockGifts(_0x2e4e96);
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(_0x39e679, _0x20f59d) {
  let _0x222807;
  return (..._0x1dcd36) => {
    clearTimeout(_0x222807), (_0x222807 = setTimeout(() => _0x39e679.apply(this, _0x1dcd36), _0x20f59d));
  };
}
function fetchConfig(_0xefd7e5 = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + _0xefd7e5,
    },
  };
}
function addDays(_0x5c1e63, _0x42e3d4) {
  var _0x50bd52 = new Date(_0x5c1e63);
  return _0x50bd52.setDate(_0x50bd52.getDate() + _0x42e3d4), _0x50bd52;
}
function formatDates(_0x5c8e8e, _0x12579e, _0x35a404 = 0x1b) {
  if (!_0x5c8e8e || !_0x12579e) return;
  const _0x26743f = new Date(_0x12579e + "T00:00:00Z"),
    _0x1f66d4 = _0x26743f.getFullYear(),
    _0x47bd5c = _0x26743f.getMonth(),
    _0x448581 = _0x26743f.getDate(),
    _0x3916bc = new Date(_0x1f66d4, _0x47bd5c, _0x448581),
    _0x324301 = _0x5c8e8e - _0x3916bc,
    _0x16140a = Math.ceil(_0x324301 / (0x3e8 * 0xe10 * 0x18));
  return _0x16140a <= _0x35a404;
}
function checkDateValidity(_0x126a94) {
  const _0x34ac66 = new Date(_0x126a94),
    _0x39bf6c = new Date("2023-01-01T00:00:00Z"),
    _0x275428 = Math.abs(_0x34ac66.getDate() - _0x39bf6c.getDate());
  return _0x275428 % 0x5 === 0x0 ? true : ![];
}
typeof window.Shopify == "undefined" && (window.Shopify = {});
(Shopify.bind = function (_0x285272, _0x411eb2) {
  return function () {
    return _0x285272.apply(_0x411eb2, arguments);
  };
}),
  (Shopify.setSelectorByValue = function (_0x1639cc, _0x72aa00) {
    for (var _0x58072c = 0x0, _0x32c28e = _0x1639cc.options.length; _0x58072c < _0x32c28e; _0x58072c++) {
      var _0x3550a6 = _0x1639cc.options[_0x58072c];
      if (_0x72aa00 == _0x3550a6.value || _0x72aa00 == _0x3550a6.innerHTML)
        return (_0x1639cc.selectedIndex = _0x58072c), _0x58072c;
    }
  }),
  (Shopify.addListener = function (_0x1dd59f, _0x37d2a4, _0x568a99) {
    _0x1dd59f.addEventListener
      ? _0x1dd59f.addEventListener(_0x37d2a4, _0x568a99, ![])
      : _0x1dd59f.attachEvent("on" + _0x37d2a4, _0x568a99);
  }),
  (Shopify.postLink = function (_0x399958, _0x520825) {
    _0x520825 = _0x520825 || {};
    var _0x175637 = _0x520825.method || "post",
      _0x4b77fc = _0x520825.parameters || {},
      _0x391a28 = document.createElement("form");
    _0x391a28.setAttribute("method", _0x175637), _0x391a28.setAttribute("action", _0x399958);
    for (var _0x6c2e9e in _0x4b77fc) {
      var _0x373369 = document.createElement("input");
      _0x373369.setAttribute("type", "hidden"),
        _0x373369.setAttribute("name", _0x6c2e9e),
        _0x373369.setAttribute("value", _0x4b77fc[_0x6c2e9e]),
        _0x391a28.appendChild(_0x373369);
    }
    document.body.appendChild(_0x391a28), _0x391a28.submit(), document.body.removeChild(_0x391a28);
  }),
  (Shopify.CountryProvinceSelector = function (_0x2ddc90, _0x37dea3, _0x24ac98) {
    (this.countryEl = document.getElementById(_0x2ddc90)),
      (this.provinceEl = document.getElementById(_0x37dea3)),
      (this.provinceContainer = document.getElementById(_0x24ac98.hideElement || _0x37dea3)),
      Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
      this.initCountry(),
      this.initProvince();
  }),
  (Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var _0x53c774 = this.countryEl.getAttribute("data-default");
      Shopify.setSelectorByValue(this.countryEl, _0x53c774), this.countryHandler();
    },
    initProvince: function () {
      var _0x579ff1 = this.provinceEl.getAttribute("data-default");
      _0x579ff1 && this.provinceEl.options.length > 0x0 && Shopify.setSelectorByValue(this.provinceEl, _0x579ff1);
    },
    countryHandler: function (_0x5a22b6) {
      var _0x94bdb1 = this.countryEl.options[this.countryEl.selectedIndex],
        _0x58f1c2 = _0x94bdb1.getAttribute("data-provinces"),
        _0xde4e85 = JSON.parse(_0x58f1c2);
      this.clearOptions(this.provinceEl);
      if (_0xde4e85 && _0xde4e85.length == 0x0) this.provinceContainer.style.display = "none";
      else {
        for (var _0x4b0240 = 0x0; _0x4b0240 < _0xde4e85.length; _0x4b0240++) {
          var _0x94bdb1 = document.createElement("option");
          (_0x94bdb1.value = _0xde4e85[_0x4b0240][0x0]),
            (_0x94bdb1.innerHTML = _0xde4e85[_0x4b0240][0x1]),
            this.provinceEl.appendChild(_0x94bdb1);
        }
        this.provinceContainer.style.display = "";
      }
    },
    clearOptions: function (_0x4fdf8b) {
      while (_0x4fdf8b.firstChild) {
        _0x4fdf8b.removeChild(_0x4fdf8b.firstChild);
      }
    },
    setOptions: function (_0x490324, _0x3c8e57) {
      for (var _0x1bb8a0 = 0x0, _0x16a1b9 = _0x3c8e57.length; _0x1bb8a0 < _0x3c8e57.length; _0x1bb8a0++) {
        var _0x32e34f = document.createElement("option");
        (_0x32e34f.value = _0x3c8e57[_0x1bb8a0]),
          (_0x32e34f.innerHTML = _0x3c8e57[_0x1bb8a0]),
          _0x490324.appendChild(_0x32e34f);
      }
    },
  });
class InternalVideo extends HTMLElement {
  constructor() {
    super(),
      (this.playButton = this.querySelector(".internal-video__play")),
      (this.noPlayBtn = this.dataset.noPlayBtn === "true"),
      (this.loaded = ![]),
      (this.suspended = ![]),
      (this.soundButton = this.querySelector(".internal-video__sound-btn")),
      (this.video = this.querySelector("video")),
      (this.invalidFormatSrc = this.video.querySelector('source[type="application/x-mpegURL"]'));
    if (this.invalidFormatSrc) this.invalidFormatSrc.remove();
    (this.timeline = this.querySelector(".internal-video__timeline")), (this.dragging = ![]);
    if (this.playButton) this.playButton.addEventListener("click", this.playVideo.bind(this));
    if (this.soundButton) this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    if (this.video) this.video.addEventListener("ended", this.endedVideo.bind(this));
    this.timeline &&
      (this.video.addEventListener("timeupdate", this.updateTimeline.bind(this)),
      this.timeline.addEventListener("click", this.seekVideo.bind(this)),
      this.timeline.addEventListener("mousedown", this.startDrag.bind(this)),
      this.timeline.addEventListener("touchstart", this.startDrag.bind(this)),
      document.addEventListener("mouseup", this.stopDrag.bind(this)),
      document.addEventListener("touchend", this.stopDrag.bind(this)),
      document.addEventListener("mousemove", this.drag.bind(this)),
      document.addEventListener("touchmove", this.drag.bind(this)));
    this.video.addEventListener("waiting", this.showSpinner.bind(this)),
      this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this)),
      this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const _0x2bf0ac = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05,
      };
      (this.observer = new IntersectionObserver(this.handleIntersection.bind(this), _0x2bf0ac)),
        this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      !this.loaded && (this.video.load(), (this.loaded = true));
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "hidden";
      const _0x2b57e8 = this.video.play();
      _0x2b57e8 !== undefined &&
        _0x2b57e8
          .then(() => {
            this.classList.add("internal-video--playing");
            if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "hidden";
          })
          ["catch"]((_0x47c1f0) => {
            this.classList.remove("internal-video--playing");
            if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "visible";
          });
    } else this.video.pause(), this.classList.remove("internal-video--playing");
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    this.video.muted
      ? ((this.video.muted = ![]), this.classList.remove("internal-video--muted"))
      : ((this.video.muted = true), this.classList.add("internal-video--muted"));
  }
  updateTimeline() {
    const _0xab22f = (this.video.currentTime / this.video.duration) * 0x64;
    this.style.setProperty("--completed", _0xab22f + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(_0x2a91c9) {
    _0x2a91c9.preventDefault(), (this.dragging = true), this.drag(_0x2a91c9);
  }
  stopDrag() {
    this.dragging = ![];
  }
  drag(_0x142828) {
    if (!this.dragging) return;
    _0x142828.touches && (_0x142828 = _0x142828.touches[0x0]), this.seekVideo(_0x142828);
  }
  seekVideo(_0x274292) {
    const _0x260ae7 = this.timeline.getBoundingClientRect(),
      _0x16b078 = _0x274292.clientX - _0x260ae7.left,
      _0x5882be = _0x16b078 / _0x260ae7.width;
    this.video.currentTime = _0x5882be * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(_0x1d1511) {
    _0x1d1511.forEach((_0x4c8c1a) => {
      if (_0x4c8c1a.isIntersecting) {
        for (let _0x391dfb of this.video.querySelectorAll("source[data-src]")) {
          _0x391dfb.setAttribute("src", _0x391dfb.getAttribute("data-src")), _0x391dfb.removeAttribute("data-src");
        }
        this.video.load();
        var _0xa155d7 = this.video.play();
        _0xa155d7 !== undefined &&
          _0xa155d7["catch"]((_0x34c3bb) => {
            if (_0x34c3bb.name === "NotAllowedError") {
              this.classList.remove("internal-video--playing");
              if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "visible";
            }
          }).then(() => {
            this.video.play();
          }),
          this.observer.disconnect();
      }
    });
  }
}
customElements.define("internal-video", InternalVideo);

class ComparisonSlider extends HTMLElement {
  constructor() {
    super(),
      (this.sliderOverlay = this.querySelector(".comparison-slider__overlay")),
      (this.sliderLine = this.querySelector(".comparison-slider__line")),
      (this.sliderInput = this.querySelector(".comparison-slider__input")),
      this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(_0x3d0ded) {
    const _0x1526e4 = _0x3d0ded.currentTarget.value;
    (this.sliderOverlay.style.width = _0x1526e4 + "%"), (this.sliderLine.style.left = _0x1526e4 + "%");
  }
}
customElements.define("comparison-slider", ComparisonSlider);

class PromoPopup extends HTMLElement {
  constructor() {
    super(),
      (this.testMode = this.dataset.testMode === "true"),
      (this.secondsDelay = this.dataset.delaySeconds),
      (this.daysFrequency = this.dataset.delayDays),
      (this.modal = this.querySelector(".sign-up-popup-modal")),
      (this.timer = this.querySelector(".popup-modal__timer")),
      (this.timerDuration = this.dataset.timerDuration),
      (this.closeBtns = this.querySelectorAll(".promp-popup__close-btn")),
      (this.overlay = document.querySelector(".sign-up-popup-overlay")),
      (this.storageKey = "promo-bar-data-" + window.location.host);
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) this.openPopupModal();
      else {
        const _0x4ec20c = JSON.parse(localStorage.getItem(this.storageKey)),
          _0x2d4920 = new Date(_0x4ec20c.next_display_date);
        currentDate.getTime() > _0x2d4920.getTime() && this.openPopupModal();
      }
    } else {
      if (this.timer) this.displayPromoTimer();
    }
    this.closeBtns.forEach((_0x5be43d) => {
      _0x5be43d.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(
      () => {
        this.modal.classList.add("popup-modal--active"), this.overlay.classList.add("popup-overlay--active");
        const _0x4b8b92 = addDays(currentDate, parseInt(this.daysFrequency)),
          _0x4aa397 = {
            next_display_date: _0x4b8b92,
            dismissed: ![],
          };
        localStorage.setItem(this.storageKey, JSON.stringify(_0x4aa397));
        if (this.timer) this.displayPromoTimer();
      },
      parseInt(this.secondsDelay) * 0x3e8 + 0xbb8,
    );
  }
  displayPromoTimer() {
    (this.minutesSpan = this.querySelector(".popup-modal__timer__minutes")),
      (this.secondsSpan = this.querySelector(".popup-modal__timer__seconds")),
      (this.totalSeconds = parseFloat(this.timerDuration) * 0x3c),
      this.updateTimer();
    const _0x27347b = setInterval(() => {
      (this.totalSeconds -= 0x1),
        this.updateTimer(),
        this.totalSeconds <= 0x0 && (this.totalSeconds = parseFloat(this.timerDuration) * 0x3c - 0x2d);
    }, 0x3e8);
  }
  updateTimer() {
    let _0x494c68 = Math.floor(this.totalSeconds / 0x3c);
    if (_0x494c68.toString().length === 0x1) _0x494c68 = "0" + _0x494c68;
    let _0x243608 = this.totalSeconds % 0x3c;
    if (_0x243608.toString().length === 0x1) _0x243608 = "0" + _0x243608;
    (this.minutesSpan.innerText = _0x494c68), (this.secondsSpan.innerText = _0x243608);
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active"), this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    super(),
      (this.sectionOneContainer = this.querySelector(".section-group__section-one-container")),
      (this.sectionTwoContainer = this.querySelector(".section-group__section-two-container")),
      this.transferSections(),
      document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  transferSections() {
    (this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping")),
      (this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping"));
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length)
      this.sectionOneContainer.appendChild(this.sectionOne);
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length)
      this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super(),
      (this.button = this.querySelector(".clickable-discount__btn")),
      this.button.addEventListener("click", this.handleClick.bind(this)),
      this.dataset.applied === "true" ? this.handleClick() : this.reapplyDiscountIfApplicable();
  }
  handleClick() {
    (this.dataset.loading = "true"),
      (this.button.disabled = true),
      (this.dataset.error = "false"),
      fetch("/discount/" + this.dataset.code)
        .then((_0x37e14f) => {
          if (!_0x37e14f.ok) throw new Error("Error");
          (this.dataset.applied = "true"), sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
        })
        ["catch"]((_0x3150ab) => {
          (this.dataset.error = "true"), (this.button.disabled = ![]);
        })
        ["finally"](() => {
          this.dataset.loading = "false";
        });
  }
  reapplyDiscountIfApplicable() {
    const _0x52e4a0 = this.dataset.code;
    sessionStorage.getItem("discount-" + _0x52e4a0 + "-applied") &&
      ((this.dataset.applied = "true"),
      (this.button.disabled = true),
      setTimeout(() => {
        fetch("/discount/" + _0x52e4a0)["catch"]((_0x365bc7) => {
          (this.dataset.applied = "false"), (this.button.disabled = ![]);
        });
      }, 0xbb8));
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super(),
      (this.dateFormat = this.dataset.dateFormat),
      (this.days = this.rearrangeDays(this.dataset.dayLabels.split(","))),
      (this.months = this.dataset.monthLabels.split(",")),
      (this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\x22true\x22]")),
      this.insertDates(),
      checkDateValidity(currentDate),
      document.addEventListener("shopify:section:load", (_0x1466e5) => {
        this.insertDates();
      });
  }
  insertDates() {
    this.elementsToChange.forEach((_0x4c94ad) => {
      const _0x103fe2 = _0x4c94ad.dataset.text,
        _0x220ed6 = parseInt(_0x4c94ad.dataset.minDays),
        _0x184aaa = parseInt(_0x4c94ad.dataset.maxDays),
        _0x88c008 = addDays(currentDate, _0x220ed6);
      let _0x20030b = "th";
      const _0x306bfe = _0x88c008.getDate();
      if (_0x306bfe === 0x1 || _0x306bfe === 0x15 || _0x306bfe === 0x1f) _0x20030b = "st";
      else {
        if (_0x306bfe === 0x2 || _0x306bfe === 0x16) _0x20030b = "nd";
        else {
          if (_0x306bfe === 0x3 || _0x306bfe === 0x17) _0x20030b = "rd";
        }
      }
      const _0x3161c1 = addDays(currentDate, _0x184aaa);
      let _0x12db2d = "th";
      const _0x513543 = _0x3161c1.getDate();
      if (_0x513543 === 0x1 || _0x513543 === 0x15 || _0x513543 === 0x1f) _0x12db2d = "st";
      else {
        if (_0x513543 === 0x2 || _0x513543 === 0x16) _0x12db2d = "nd";
        else {
          if (_0x513543 === 0x3 || _0x513543 === 0x17) _0x12db2d = "rd";
        }
      }
      let _0x46fa74, _0x2a5bbb;
      if (this.dateFormat === "day_dd_mm")
        (_0x46fa74 =
          this.days[_0x88c008.getDay()] + ",\x20" + _0x88c008.getDate() + ".\x20" + this.months[_0x88c008.getMonth()]),
          (_0x2a5bbb =
            this.days[_0x3161c1.getDay()] +
            ",\x20" +
            _0x3161c1.getDate() +
            ".\x20" +
            this.months[_0x3161c1.getMonth()]);
      else {
        if (this.dateFormat === "mm_dd")
          (_0x46fa74 = this.months[_0x88c008.getMonth()] + "\x20" + _0x88c008.getDate() + _0x20030b),
            (_0x2a5bbb = this.months[_0x3161c1.getMonth()] + "\x20" + _0x3161c1.getDate() + _0x12db2d);
        else {
          if (this.dateFormat === "dd_mm")
            (_0x46fa74 = _0x88c008.getDate() + ".\x20" + this.months[_0x88c008.getMonth()]),
              (_0x2a5bbb = _0x3161c1.getDate() + ".\x20" + this.months[_0x3161c1.getMonth()]);
          else {
            if (this.dateFormat === "dd_mm_no_dot")
              (_0x46fa74 = _0x88c008.getDate() + "\x20" + this.months[_0x88c008.getMonth()]),
                (_0x2a5bbb = _0x3161c1.getDate() + "\x20" + this.months[_0x3161c1.getMonth()]);
            else {
              if (this.dateFormat === "day_dd_mm_numeric") {
                const _0x2c10ff =
                    String(_0x88c008.getDate()).length > 0x1 ? _0x88c008.getDate() : "0" + _0x88c008.getDate(),
                  _0x2c544c =
                    String(_0x88c008.getMonth() + 0x1).length > 0x1
                      ? _0x88c008.getMonth() + 0x1
                      : "0" + (_0x88c008.getMonth() + 0x1);
                _0x46fa74 = this.days[_0x88c008.getDay()] + ",\x20" + _0x2c10ff + ".\x20" + _0x2c544c + ".";
                const _0x4e1983 =
                    String(_0x3161c1.getDate()).length > 0x1 ? _0x3161c1.getDate() : "0" + _0x3161c1.getDate(),
                  _0x3b87cf =
                    String(_0x3161c1.getMonth() + 0x1).length > 0x1
                      ? _0x3161c1.getMonth() + 0x1
                      : "0" + (_0x3161c1.getMonth() + 0x1);
                _0x2a5bbb = this.days[_0x3161c1.getDay()] + ",\x20" + _0x4e1983 + ".\x20" + _0x3b87cf + ".";
              } else {
                if (this.dateFormat === "dd_mm_numeric") {
                  const _0x2b8ad2 =
                      String(_0x88c008.getDate()).length > 0x1 ? _0x88c008.getDate() : "0" + _0x88c008.getDate(),
                    _0x10eaa9 =
                      String(_0x88c008.getMonth() + 0x1).length > 0x1
                        ? _0x88c008.getMonth() + 0x1
                        : "0" + (_0x88c008.getMonth() + 0x1);
                  _0x46fa74 = _0x2b8ad2 + ".\x20" + _0x10eaa9 + ".";
                  const _0x2c6789 =
                      String(_0x3161c1.getDate()).length > 0x1 ? _0x3161c1.getDate() : "0" + _0x3161c1.getDate(),
                    _0x26dcbe =
                      String(_0x3161c1.getMonth() + 0x1).length > 0x1
                        ? _0x3161c1.getMonth() + 0x1
                        : "0" + (_0x3161c1.getMonth() + 0x1);
                  _0x2a5bbb = _0x2c6789 + ".\x20" + _0x26dcbe + ".";
                } else
                  (_0x46fa74 =
                    this.days[_0x88c008.getDay()] +
                    ",\x20" +
                    this.months[_0x88c008.getMonth()] +
                    "\x20" +
                    _0x88c008.getDate() +
                    _0x20030b),
                    (_0x2a5bbb =
                      this.days[_0x3161c1.getDay()] +
                      ",\x20" +
                      this.months[_0x3161c1.getMonth()] +
                      "\x20" +
                      _0x3161c1.getDate() +
                      _0x12db2d);
              }
            }
          }
        }
      }
      const _0x4c8c90 = _0x103fe2.replace("[start_date]", _0x46fa74),
        _0x5bd6f9 = _0x4c8c90.replace("[end_date]", _0x2a5bbb);
      _0x4c94ad.innerHTML = _0x5bd6f9;
    });
  }
  rearrangeDays(_0x280d3b) {
    return _0x280d3b.unshift(_0x280d3b[0x6]), (_0x280d3b.length = 0x7), _0x280d3b;
  }
}

customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super(),
      (this.isAfterScroll = this.dataset.afterScroll === "true"),
      (this.isScrollBtn = this.dataset.scrollBtn === "true"),
      (this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section)),
      (this.floatingBtns = document.querySelectorAll(".floating-btn")),
      this.footerSpacing();
    this.isAfterScroll
      ? this.mainAtcBtn && (this.checkATCScroll(), document.addEventListener("scroll", this.checkATCScroll.bind(this)))
      : this.floatingBtns.forEach((_0x5e57a3) => {
          _0x5e57a3.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
        });
    if (this.isScrollBtn) {
      (this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn")),
        (this.scrollDestination = document.querySelector(
          "" + this.dataset.scrollDestination.replace("id", this.dataset.section),
        ));
      if (this.scrollBtn && this.scrollDestination)
        this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
    }
  }
  checkATCScroll() {
    window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight
      ? ((this.style.transform = "none"), (this.scrolledPast = true))
      : ((this.style.transform = ""), (this.scrolledPast = ![])),
      this.floatingBtns.forEach((_0x13d191) => {
        this.scrolledPast
          ? _0x13d191.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px")
          : _0x13d191.style.setProperty("--sticky-atc-offset", "0px");
      });
  }
  handleScrollBtn() {
    const _0x49fe55 = document.querySelector("sticky-header"),
      _0x19bc56 = _0x49fe55 ? _0x49fe55.clientHeight : 0x0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - _0x19bc56 - 0xf,
      behavior: "smooth",
    });
  }
  footerSpacing() {
    let _0x2cdfe1 = document.querySelector(".sticky-atc-footer-spacer");
    if (_0x2cdfe1) return;
    (_0x2cdfe1 = document.createElement("div")),
      (_0x2cdfe1.className = "sticky-atc-footer-spacer"),
      (_0x2cdfe1.style.height = this.clientHeight - 0x1 + "px"),
      (_0x2cdfe1.style.display = "block");
    const _0x3d5fd1 = document.querySelector(".footer");
    if (_0x3d5fd1) _0x2cdfe1.style.background = window.getComputedStyle(_0x3d5fd1).background;
    document.body.appendChild(_0x2cdfe1);
  }
}
customElements.define("sticky-atc", StickyAtc),
  (function () {
    if (!formatDates(currentDate, date)) {
      var _0x241c5c = "shopify";
      if (!window.location.hostname.includes(_0x241c5c)) {
        if (document.querySelector(".m" + "ain-pr" + "oduct-fo" + "rm"))
          document.querySelector(".m" + "ain-pr" + "oduct-fo" + "rm").isCartUpsell = true;
      }
    }
  })();
class BundleDeals extends HTMLElement {
  constructor() {
    super(),
      (this.productContainers = this.querySelectorAll(".bundle-deals__product-js")),
      (this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js")),
      (this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js")),
      (this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js")),
      (this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js")),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      (this.prices = this.querySelectorAll(".bundle-deals__price-js")),
      (this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js")),
      (this.totalPrice = this.querySelector(".bundle-deals__total-price-js")),
      (this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js")),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
      (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
      (this.currencySymbol = this.dataset.currencySymbol),
      (this.selectedVariants = {
        id_1: null,
        id_2: null,
        id_3: null,
        id_4: null,
        id_5: null,
      }),
      (this.formVariants = []),
      this.initIds(),
      this.checkboxes.forEach((_0x2b0573) => {
        _0x2b0573.addEventListener("change", this.handleCheckboxChange.bind(this));
      }),
      this.variantPickers.forEach((_0x43c662) => {
        _0x43c662.addEventListener("change", this.handleSelectChange.bind(this));
      });
  }
  initIds() {
    this.checkboxes.forEach((_0x5840f3) => {
      this.selectedVariants[_0x5840f3.dataset.idIndex] = {
        id: _0x5840f3.dataset.id,
        price: _0x5840f3.dataset.price,
        comparePrice: _0x5840f3.dataset.comparePrice,
        checked: true,
      };
    }),
      this.updateFormIds();
  }
  handleCheckboxChange(_0xef6cf0) {
    const _0x187b40 = _0xef6cf0.currentTarget,
      _0x5e32c2 = _0x187b40.checked,
      _0x4b853c = parseInt(_0x187b40.dataset.index);
    this.selectedVariants[_0x187b40.dataset.idIndex].checked = _0x5e32c2;
    const _0x4c70e0 = this.productContainers[_0x4b853c],
      _0x4aa752 = _0x4c70e0.querySelectorAll("select");
    _0x5e32c2
      ? (this.mediaItemContainers[_0x4b853c].classList.remove("bundle-deals__media-item--disabled"),
        _0x4c70e0.classList.remove("bundle-deals__product--deselected"),
        _0x4aa752.forEach((_0x432b50) => {
          _0x432b50.removeAttribute("disabled");
        }))
      : (this.mediaItemContainers[_0x4b853c].classList.add("bundle-deals__media-item--disabled"),
        _0x4c70e0.classList.add("bundle-deals__product--deselected"),
        _0x4aa752.forEach((_0x5826a9) => {
          _0x5826a9.setAttribute("disabled", "");
        }));
    this.updateFormIds();
    if (this.updatePrices) this.updateTotalPrice();
  }
  handleSelectChange(_0x125ae1) {
    const _0x3ba955 = _0x125ae1.currentTarget,
      _0x533c56 = parseInt(_0x3ba955.dataset.index),
      _0x2242e3 = Array.from(_0x3ba955.querySelectorAll("select"), (_0x1b1ed9) => _0x1b1ed9.value),
      _0x182ae6 = JSON.parse(_0x3ba955.querySelector('[type="application/json"]').textContent).filter(
        (_0x3346c1) => _0x3ba955.querySelector(":checked").value === _0x3346c1.option1,
      ),
      _0x453b63 = [..._0x3ba955.querySelectorAll(".select--small")];
    updateVariantStatuses(_0x182ae6, _0x453b63);
    const _0x3f7a73 = JSON.parse(_0x3ba955.querySelector("[type=\x22application/json\x22]").textContent).find(
      (_0x2dd2dc) => {
        return !_0x2dd2dc.options
          .map((_0x404ac0, _0xfb3d83) => {
            return _0x2242e3[_0xfb3d83] === _0x404ac0;
          })
          .includes(![]);
      },
    );
    if (!_0x3f7a73) {
      if (this.skipNonExistent) findAvailableVariant(_0x3ba955, _0x2242e3, ![], true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !_0x3f7a73.available) {
      if (findAvailableVariant(_0x3ba955, _0x2242e3, ![], true, true)) return;
    }
    let { price: _0x22ea81, compare_at_price: _0x382dbe, featured_image: _0x5e4747 } = _0x3f7a73;
    _0x22ea81 = parseInt(_0x22ea81);
    let _0x3d79b2 = _0x382dbe ? parseInt(_0x382dbe) : _0x22ea81;
    const _0x152124 = _0x3ba955.dataset.percentageLeft ?? 0x1,
      _0x172a49 = _0x3ba955.dataset.fixedDiscount ?? 0x0;
    _0x22ea81 = _0x22ea81 * _0x152124 - _0x172a49;
    if (_0x5e4747) _0x5e4747 = _0x5e4747.src;
    const _0x58a6bd = _0x3f7a73.id;
    (this.selectedVariants[_0x3ba955.dataset.idIndex].id = _0x58a6bd),
      (this.selectedVariants[_0x3ba955.dataset.idIndex].price = _0x22ea81),
      (this.selectedVariants[_0x3ba955.dataset.idIndex].comparePrice = _0x3d79b2),
      this.updateFormIds(),
      this.updatePrices &&
        ((this.prices[_0x533c56].innerHTML = this.currencySymbol + (_0x22ea81 / 0x64).toFixed(0x2)),
        _0x3d79b2 > _0x22ea81
          ? (this.comparePrices[_0x533c56].innerHTML = this.currencySymbol + (_0x3d79b2 / 0x64).toFixed(0x2))
          : (this.comparePrices[_0x533c56].innerHTML = ""),
        this.updateTotalPrice()),
      _0x5e4747 &&
        _0x5e4747.length > 0x0 &&
        this.mediaItemImgs[_0x533c56] &&
        (this.mediaItemImgs[_0x533c56].src = _0x5e4747);
  }
  updateFormIds() {
    const _0x7bb2ab = [],
      _0x5724eb = this.selectedVariants;
    for (const _0xb7b5e in _0x5724eb) {
      const _0x40f2bb = _0x5724eb[_0xb7b5e];
      if (_0x40f2bb != null && _0x40f2bb.checked) {
        const _0x235da6 = _0x7bb2ab.findIndex((_0x53e52b) => _0x53e52b.id === _0x40f2bb.id);
        _0x235da6 < 0x0
          ? _0x7bb2ab.unshift({
              id: _0x40f2bb.id,
              quantity: 0x1,
            })
          : (_0x7bb2ab[_0x235da6].quantity += 0x1);
      }
    }
    this.formVariants = _0x7bb2ab;
  }
  updateTotalPrice() {
    const _0x34e8e6 = [],
      _0x33a085 = [],
      _0x2b05d4 = this.selectedVariants;
    for (const _0x3d58a5 in _0x2b05d4) {
      const _0x46cb89 = _0x2b05d4[_0x3d58a5];
      _0x46cb89 != null &&
        _0x46cb89.checked &&
        (_0x34e8e6.push(parseInt(_0x46cb89.price)), _0x33a085.push(parseInt(_0x46cb89.comparePrice)));
    }
    const _0x27f25e = _0x34e8e6.reduce((_0x1600af, _0x2517b0) => _0x1600af + _0x2517b0, 0x0),
      _0x2731d2 = _0x27f25e * this.percentageLeft - this.fixedDiscount,
      _0x8ae77b = _0x33a085.reduce((_0x4ccd3f, _0x2f3a35) => _0x4ccd3f + _0x2f3a35, 0x0);
    (this.totalPrice.innerHTML = this.currencySymbol + (_0x2731d2 / 0x64).toFixed(0x2)),
      _0x8ae77b > _0x2731d2
        ? (this.totalComparePrice.innerHTML = this.currencySymbol + (_0x8ae77b / 0x64).toFixed(0x2))
        : (this.totalComparePrice.innerHTML = "");
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super(),
      (this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section)),
      (this.inputs = this.querySelectorAll("input[name=\x22quantity\x22]")),
      (this.labels = this.querySelectorAll(".quantity-break")),
      (this.jsonData = this.querySelector("[type=\x22application/json\x22]")),
      (this.hasVariants = this.jsonData.dataset.hasVariants === "true"),
      (this.selectedVariants = {
        input_1: [],
        input_2: [],
        input_3: [],
        input_4: [],
        input_5: [],
        input_6: [],
      }),
      (this.updateUnavailable = this.dataset.updateUnavailable === "true"),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      (this.formVariants = []),
      (this.selectedQuantity = 0x1);
    if (this.querySelector("input[checked]"))
      this.selectedQuantity = parseInt(this.querySelector("input[checked]").value);
    (this.variantSelects = this.querySelectorAll(".quantity-break__selector-item")),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      (this.moneyFormat = this.dataset.moneyFormat);
    if (this.hasVariants) this.initVariants();
    this.inputs.forEach((_0x5ebd26) => {
      _0x5ebd26.addEventListener("change", this.handleChange.bind(this));
    }),
      this.variantSelects.forEach((_0x48d211) => {
        _0x48d211.addEventListener("change", this.handleSelectChange.bind(this));
      });
  }
  handleSelectChange(_0x14cd7a) {
    const _0x2c5ef9 = _0x14cd7a.currentTarget,
      _0x4c3193 = Array.from(_0x2c5ef9.querySelectorAll("select"), (_0x2da43c) => _0x2da43c.value);
    if (this.updateUnavailable) {
      const _0x3fa2bc = this.getVariantData().filter(
          (_0x25dbd0) => _0x2c5ef9.querySelector(":checked").value === _0x25dbd0.option1,
        ),
        _0x558e90 = [..._0x2c5ef9.querySelectorAll(".select--small")];
      updateVariantStatuses(_0x3fa2bc, _0x558e90);
    }
    const _0x5dd737 = this.getVariantData().find((_0x1c2d5a) => {
      return !_0x1c2d5a.options
        .map((_0x55229e, _0x5b8cd5) => {
          return _0x4c3193[_0x5b8cd5] === _0x55229e;
        })
        .includes(![]);
    });
    if (!_0x5dd737) {
      if (this.skipNonExistent) findAvailableVariant(_0x2c5ef9, _0x4c3193, ![], true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !_0x5dd737.available) {
      if (findAvailableVariant(_0x2c5ef9, _0x4c3193, ![], true, true)) return;
    }
    _0x2c5ef9.dataset.selectedId = _0x5dd737.id;
    const _0x71c1b0 = _0x2c5ef9.dataset.selectIndex,
      _0x2d0a98 = _0x2c5ef9.closest(".quantity-break"),
      _0x55bb6e = _0x2d0a98.dataset.input;
    (this.selectedVariants[_0x55bb6e][_0x71c1b0] = _0x5dd737.id),
      (this.formVariants = this.selectedVariants[_0x55bb6e]),
      this.updateMedia(_0x5dd737);
    if (!this.updatePrices) return;
    var _0x56ed9d = 0x0,
      _0x558579 = 0x0;
    const _0x2728a2 = parseFloat(_0x2d0a98.dataset.quantity),
      _0x4ef28c = parseFloat(_0x2d0a98.dataset.percentageLeft),
      _0x2a111f = parseFloat(_0x2d0a98.dataset.fixedDiscount);
    for (let _0x5107df = 0x0; _0x5107df < _0x2728a2; _0x5107df++) {
      const _0x47b1ca = parseInt(this.selectedVariants[_0x55bb6e][_0x5107df]),
        _0x1241d1 = this.getVariantData().find((_0xfc9bda) => parseInt(_0xfc9bda.id) === _0x47b1ca);
      if (!_0x1241d1) return;
      (_0x56ed9d += _0x1241d1.price),
        _0x1241d1.compare_at_price && _0x1241d1.compare_at_price > _0x1241d1.price
          ? (_0x558579 += _0x1241d1.compare_at_price)
          : (_0x558579 += _0x1241d1.price);
    }
    _0x56ed9d = _0x56ed9d * _0x4ef28c - _0x2a111f;
    const _0x5c6f15 = _0x558579 - _0x56ed9d,
      _0x2e82dd = Math.round(_0x5c6f15 / 0x64) * 0x64,
      _0x4621e9 = _0x56ed9d / _0x2728a2,
      _0x1b6e7a = _0x558579 / _0x2728a2,
      _0x59821a = formatMoney(_0x56ed9d, this.moneyFormat, true),
      _0x1237e8 = formatMoney(_0x558579, this.moneyFormat, true),
      _0x29ecfd = formatMoney(_0x5c6f15, this.moneyFormat, true),
      _0x2bb440 = formatMoney(_0x2e82dd, this.moneyFormat, true),
      _0x3a7509 = formatMoney(_0x4621e9, this.moneyFormat, true),
      _0x3b6c71 = formatMoney(_0x1b6e7a, this.moneyFormat, true);
    _0x2d0a98.querySelectorAll(".variant-price-update").forEach((_0x345401) => {
      let _0x405124 = _0x345401.dataset.text;
      (_0x405124 = _0x405124.replace("[quantity]", _0x2728a2)),
        (_0x405124 = _0x405124.replace("[price]", _0x59821a)),
        (_0x405124 = _0x405124.replace("[compare_price]", _0x1237e8)),
        (_0x405124 = _0x405124.replace("[amount_saved]", _0x29ecfd)),
        (_0x405124 = _0x405124.replace("[amount_saved_rounded]", _0x2bb440)),
        (_0x405124 = _0x405124.replace("[price_each]", _0x3a7509)),
        (_0x405124 = _0x405124.replace("[compare_price_each]", _0x3b6c71)),
        (_0x345401.innerHTML = _0x405124);
    });
    const _0x1e1a6a = _0x2d0a98.querySelector(".quantity-break__compare-price");
    _0x1e1a6a && (_0x558579 > _0x56ed9d ? _0x1e1a6a.classList.remove("hidden") : _0x1e1a6a.classList.add("hidden"));
  }
  getVariantData() {
    return (this.variantData = this.variantData || JSON.parse(this.jsonData.textContent)), this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) return;
    this.labels.forEach((_0x38e6e5) => {
      if (_0x38e6e5.querySelector(".quantity-break__variants")) {
        let _0x49bb1c = [];
        _0x38e6e5.querySelectorAll(".quantity-break__selector-item").forEach((_0x53db3) => {
          _0x49bb1c.push(_0x53db3.dataset.selectedId);
        }),
          (this.selectedVariants[_0x38e6e5.dataset.input] = _0x49bb1c);
      }
    }),
      (this.formVariants = []);
  }
  updateMedia(_0x3e340b) {
    if (!_0x3e340b) return;
    if (!_0x3e340b.featured_media) return;
    const _0x23a346 = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + "\x22]");
    _0x23a346.forEach((_0x2ea84e) =>
      _0x2ea84e.setActiveMedia(this.dataset.section + "-" + _0x3e340b.featured_media.id, true),
    );
  }
  handleChange(_0x120c99) {
    const _0x238441 = parseInt(_0x120c99.target.value);
    this.selectedQuantity = _0x238441;
    if (this.hasVariants) this.formVariants = this.selectedVariants[_0x120c99.target.dataset.input];
    if (this.quantityGifts) this.quantityGifts.unlockGifts(_0x238441);
  }
}
customElements.define("quantity-breaks", QuantityBreaks);

function updateVariantStatuses(_0x223cb0, _0x566eb5) {
  _0x566eb5.forEach((_0x1c5814, _0x318ec3) => {
    if (_0x318ec3 === 0x0) return;
    const _0x4d70cc = [..._0x1c5814.querySelectorAll("option")],
      _0x10d44d = _0x566eb5[_0x318ec3 - 0x1].querySelector(":checked").value,
      _0xde17c6 = _0x223cb0
        .filter((_0x30f692) => _0x30f692.available && _0x30f692["option" + _0x318ec3] === _0x10d44d)
        .map((_0x5a49ad) => _0x5a49ad["option" + (_0x318ec3 + 0x1)]),
      _0x3602ef = _0x223cb0
        .filter((_0x41235a) => _0x41235a["option" + _0x318ec3] === _0x10d44d)
        .map((_0x83c31f) => _0x83c31f["option" + (_0x318ec3 + 0x1)]);
    _0x4d70cc.forEach((_0x2fafce) => {
      _0x2fafce.classList.remove("unavailable", "non-existent"),
        _0x3602ef.includes(_0x2fafce.getAttribute("value"))
          ? _0xde17c6.includes(_0x2fafce.getAttribute("value"))
            ? (_0x2fafce.innerText = _0x2fafce.getAttribute("value"))
            : ((_0x2fafce.innerText = window.variantStrings.unavailable_with_option.replace(
                "[value]",
                _0x2fafce.getAttribute("value"),
              )),
              _0x2fafce.classList.add("unavailable"))
          : ((_0x2fafce.innerText = window.variantStrings.unavailable_with_option.replace(
              "[value]",
              _0x2fafce.getAttribute("value"),
            )),
            _0x2fafce.classList.add("non-existent"));
    });
  });
}
function findAvailableVariant(_0x3c8d7b, _0x141564, _0x44e35f = true, _0x22822c = ![], _0x8bbd96 = ![]) {
  console.log("Running findAvailableVariant");
  for (let _0x4796b0 = _0x141564.length - 0x1; _0x4796b0 >= 0x0; _0x4796b0--) {
    const _0x555d06 = _0x44e35f
        ? _0x3c8d7b.querySelector(".product-form__input:nth-child(" + (_0x4796b0 + 0x1) + ")")
        : _0x3c8d7b.querySelectorAll(".select")[_0x4796b0],
      _0x1bc1f0 = _0x44e35f ? _0x555d06.querySelector(".product-form__input__type").dataset.type : "dropdown",
      _0x54956e =
        _0x1bc1f0 === "dropdown"
          ? _0x555d06.querySelectorAll("option")
          : _0x555d06.querySelectorAll('input[type="radio"]');
    let _0x4ea003 = Array.from(_0x54956e).findIndex((_0x471d4c) => _0x471d4c.value === _0x141564[_0x4796b0]),
      _0x462ec3 = ![];
    while (_0x4ea003 < _0x54956e.length - 0x1) {
      _0x4ea003++;
      const _0x2493e3 = _0x54956e[_0x4ea003];
      if (
        (!_0x22822c || !_0x2493e3.classList.contains("non-existent")) &&
        (!_0x8bbd96 || !_0x2493e3.classList.contains("unavailable"))
      ) {
        (_0x141564[_0x4796b0] = _0x2493e3.value), (_0x462ec3 = true);
        break;
      }
    }
    if (!_0x462ec3) {
      _0x4ea003 = Array.from(_0x54956e).findIndex((_0x493ff) => _0x493ff.value === _0x141564[_0x4796b0]);
      while (_0x4ea003 > 0x0) {
        _0x4ea003--;
        const _0x2e95f6 = _0x54956e[_0x4ea003];
        if (
          (!_0x22822c || !_0x2e95f6.classList.contains("non-existent")) &&
          (!_0x8bbd96 || !_0x2e95f6.classList.contains("unavailable"))
        ) {
          (_0x141564[_0x4796b0] = _0x2e95f6.value), (_0x462ec3 = true);
          break;
        }
      }
    }
    if (_0x462ec3)
      return (
        _0x1bc1f0 === "dropdown"
          ? (_0x555d06.querySelector(".select__select").value = _0x141564[_0x4796b0])
          : (_0x555d06.querySelector("input[type=\x22radio\x22][value=\x22" + _0x141564[_0x4796b0] + "\x22]").checked =
              true),
        _0x3c8d7b.dispatchEvent(new Event("change")),
        true
      );
  }
  return ![];
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super(),
      (this.gifts = this.querySelectorAll(".quantity-gift")),
      (this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section)),
      (this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section)),
      (this.unlockedItems = []),
      this.initUnlock();
  }
  initUnlock() {
    let _0x1034d1 = 0x1;
    if (this.quantityBreaks) _0x1034d1 = parseInt(this.quantityBreaks.selectedQuantity);
    else {
      if (this.quantitySelector) {
        const _0x205286 = this.quantitySelector.querySelector("input[name=\x22quantity\x22]");
        _0x1034d1 = parseInt(_0x205286.value);
      }
    }
    this.unlockGifts(_0x1034d1);
  }
  unlockGifts(_0x191a6d) {
    (this.unlockedItems = []),
      this.gifts.forEach((_0xdea8d3) => {
        parseInt(_0xdea8d3.dataset.quantity) <= _0x191a6d
          ? (_0xdea8d3.classList.add("quantity-gift--unlocked"),
            (_0xdea8d3.dataset.unlocked = "true"),
            this.unlockedItems.unshift(_0xdea8d3.dataset.product))
          : (_0xdea8d3.classList.remove("quantity-gift--unlocked"), (_0xdea8d3.dataset.unlocked = "false"));
      });
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super(),
      (this.image = this.querySelector(".upsell__image__img")),
      (this.toggleBtn = this.querySelector(".upsell-toggle-btn")),
      (this.variantSelects = this.querySelector(".upsell__variant-picker")),
      (this.variantSelectElements = this.querySelectorAll(".select__select")),
      (this.jsonData = this.querySelector("[type=\x22application/json\x22]")),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      (this.updatePrices = this.dataset.updatePrices === "true");
    if (this.updatePrices) {
      (this.price = parseInt(this.dataset.price)),
        (this.comparePrice = parseInt(this.dataset.comparePrice)),
        (this.priceSpan = this.querySelector(".upsell__price\x20.regular-price")),
        (this.comparePriceSpan = this.querySelector(".upsell__price\x20.compare-price")),
        (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
        (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
        (this.moneyFormat = this.dataset.moneyFormat),
        (this.isMainOfferItem = this.dataset.mainOfferItem === "true");
      if (this.isMainOfferItem)
        this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
    }
    if (this.toggleBtn) this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    if (this.variantSelects) this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
  }
  handleToggle(_0x47a5c4) {
    if (_0x47a5c4.target.nodeName.toLowerCase() === "select" || _0x47a5c4.target.nodeName.toLowerCase() === "option")
      return;
    this.dataset.selected === "true" ? (this.dataset.selected = "false") : (this.dataset.selected = "true");
  }
  handleSelectChange(_0x446859) {
    const _0xbbc2ae = _0x446859.currentTarget,
      _0x5f4312 = Array.from(_0xbbc2ae.querySelectorAll("select"), (_0x154202) => _0x154202.value),
      _0x1bbc50 = this.getVariantData().find((_0xe07b) => {
        return !_0xe07b.options
          .map((_0x56e617, _0x1b59ff) => {
            return _0x5f4312[_0x1b59ff] === _0x56e617;
          })
          .includes(![]);
      }),
      _0x175e8c = this.getVariantData().filter(
        (_0x32cc37) => _0xbbc2ae.querySelector(":checked").value === _0x32cc37.option1,
      ),
      _0x30fab2 = [..._0xbbc2ae.querySelectorAll("select")];
    updateVariantStatuses(_0x175e8c, _0x30fab2);
    if (!_0x1bbc50) {
      if (this.skipNonExistent) findAvailableVariant(_0xbbc2ae, _0x5f4312, ![], true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !_0x1bbc50.available) {
      if (findAvailableVariant(_0xbbc2ae, _0x5f4312, ![], true, true)) return;
    }
    this.updatePrices &&
      ((this.price = _0x1bbc50.price * this.percentageLeft - this.fixedDiscount),
      (this.comparePrice = _0x1bbc50.price),
      _0x1bbc50.compare_at_price &&
        _0x1bbc50.compare_at_price > _0x1bbc50.price &&
        (this.comparePrice = _0x1bbc50.compare_at_price),
      displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat));
    if (this.image && _0x1bbc50.featured_image) this.image.src = _0x1bbc50.featured_image.src;
    this.updateId(_0x1bbc50.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) this.mainOfferContainer.updateTotalPrices();
  }
  updateId(_0x47c007) {
    this.dataset.id = _0x47c007;
  }
  getVariantData() {
    return (this.variantData = this.variantData || JSON.parse(this.jsonData.textContent)), this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super(),
      (this.cartDrawer = document.querySelector("cart-drawer")),
      (this.cartItems = this.cartDrawer.querySelector("cart-drawer-items")),
      (this.productForm = this.querySelector("product-form")),
      (this.idInput = this.productForm.querySelector('[name="id"]')),
      (this.classicAddButton = this.querySelector(".upsell__add-btn"));
  }
  handleToggle(_0x201aa4) {
    if (_0x201aa4.target.nodeName.toLowerCase() === "select" || _0x201aa4.target.nodeName.toLowerCase() === "option")
      return;
    this.dataset.selected === "true"
      ? ((this.dataset.selected = "false"), this.removeFromCart())
      : ((this.dataset.selected = "true"), this.addToCart());
  }
  addRemoveFromCart() {
    this.dataset.selected === "true" && !this.cartDrawer.classList.contains("is-empty")
      ? this.addToCart()
      : this.removeFromCart();
  }
  addToCart() {
    const _0x1e2ea5 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (_0x1e2ea5) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute("disabled", "");
    this.variantSelectElements.forEach((_0x3b64e2) => {
      _0x3b64e2.setAttribute("disabled", "");
    }),
      this.productForm.handleSubmit();
  }
  removeFromCart() {
    const _0x1f3041 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (!_0x1f3041 || !this.cartItems) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute("disabled", "");
    this.variantSelectElements.forEach((_0x23bdc6) => {
      _0x23bdc6.setAttribute("disabled", "");
    }),
      this.cartItems.updateQuantity(_0x1f3041.dataset.index, 0x0);
  }
  updateId(_0x11dd42) {
    (this.dataset.id = _0x11dd42), (this.idInput.value = _0x11dd42);
    if (this.classicAddButton) return;
    if (this.dataset.selected === "true") {
      this.selectTimeout && clearTimeout(this.selectTimeout);
      this.removeFromCart();
      const _0x36f727 = (_0x501dc3) => {
        _0x501dc3.detail.handle === "handle" &&
          (this.addToCart(), document.removeEventListener("cartQuantityUpdated", _0x36f727));
      };
      document.addEventListener("cartQuantityUpdated", _0x36f727);
    }
  }
  getUpdateRequired() {
    const _0x85adee = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    let _0x130665 = ![];
    if (_0x85adee && this.dataset.selected === "false") _0x130665 = true;
    else !_0x85adee && this.dataset.selected === "true" && (_0x130665 = true);
    return _0x130665;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(_0x293317, _0x205a5e, _0x3d2463, _0x48edb5, _0xe3c513) {
  if (!_0xe3c513) return;
  if (_0x293317 && _0x3d2463) {
    var _0x3bd2a0 = formatMoney(_0x293317, _0xe3c513);
    _0x3d2463.innerHTML = _0x3bd2a0;
  }
  if (_0x205a5e && _0x48edb5) {
    var _0x244206 = formatMoney(_0x205a5e, _0xe3c513);
    (_0x48edb5.innerHTML = _0x244206),
      _0x205a5e > _0x293317 ? _0x48edb5.classList.remove("hidden") : _0x48edb5.classList.add("hidden");
  }
}

function formatMoney(_0x4773be, _0xcccbba, _0x373f28 = ![]) {
  typeof _0x4773be == "string" && (_0x4773be = _0x4773be.replace(".", ""));
  var _0x3de413 = "",
    _0x1ab89a = /\{\{\s*(\w+)\s*\}\}/,
    _0x5d8a12 = _0xcccbba;
  function _0x39353a(_0x39cfc3, _0x1f502c) {
    return typeof _0x39cfc3 == "undefined" ? _0x1f502c : _0x39cfc3;
  }
  function _0x134403(_0x505793, _0x56d96d, _0x280ade, _0x5a5997) {
    (_0x56d96d = _0x39353a(_0x56d96d, 0x2)),
      (_0x280ade = _0x39353a(_0x280ade, ",")),
      (_0x5a5997 = _0x39353a(_0x5a5997, "."));
    if (isNaN(_0x505793) || _0x505793 == null) return 0x0;
    _0x505793 = (_0x505793 / 0x64).toFixed(_0x56d96d);
    var _0x15c1cb = _0x505793.split("."),
      _0x46e046 = _0x15c1cb[0x0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + _0x280ade),
      _0x2adf18 = _0x15c1cb[0x1] ? _0x5a5997 + _0x15c1cb[0x1] : "";
    return _0x373f28 && _0x2adf18 === _0x5a5997 + "00" && (_0x2adf18 = ""), _0x46e046 + _0x2adf18;
  }
  switch (_0x5d8a12.match(_0x1ab89a)[0x1]) {
    case "amount":
      _0x3de413 = _0x134403(_0x4773be, 0x2);
      break;
    case "amount_no_decimals":
      _0x3de413 = _0x134403(_0x4773be, 0x0);
      break;
    case "amount_with_comma_separator":
      _0x3de413 = _0x134403(_0x4773be, 0x2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      _0x3de413 = _0x134403(_0x4773be, 0x0, ".", ",");
      break;
  }
  return _0x5d8a12.replace(_0x1ab89a, _0x3de413);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const _0x495148 = document.querySelector("cart-drawer");
  _0x495148 &&
    _0x495148.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift').forEach((_0x436057) => {
      if (_0x436057.addRemoveFromCart) _0x436057.addRemoveFromCart();
    });
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super(),
      (this.offerItems = this.querySelectorAll(".main-offer-item")),
      (this.updatePrices = this.dataset.updatePrices === "true"),
      this.updatePrices &&
        ((this.priceSpan = this.querySelector(".bundle-deals__total-price-js")),
        (this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js")),
        (this.percentageLeft = parseFloat(this.dataset.percentageLeft)),
        (this.fixedDiscount = parseFloat(this.dataset.fixedDiscount)),
        (this.moneyFormat = this.dataset.moneyFormat));
  }
  updateTotalPrices() {
    if (!this.updatePrices) return;
    var _0x1c5ecc = 0x0,
      _0x5bf717 = 0x0;
    for (let _0x1d6ddd = 0x0; _0x1d6ddd < this.offerItems.length; _0x1d6ddd++) {
      (_0x1c5ecc += parseInt(this.offerItems[_0x1d6ddd].price)),
        (_0x5bf717 += parseInt(this.offerItems[_0x1d6ddd].comparePrice));
    }
    (_0x1c5ecc = _0x1c5ecc * this.percentageLeft - this.fixedDiscount),
      displayPrices(_0x1c5ecc, _0x5bf717, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.fieldName = this.dataset.name),
      (this.input = this.querySelector('[type="text"], [type="number"], textarea')),
      (this.inputRadios = this.querySelectorAll("[type=\x22radio\x22]")),
      (this.select = this.querySelector(".select__select")),
      (this.productForm = document.getElementById("product-form-" + this.dataset.section)),
      (this.prevValue = this.dataset.defaultValue),
      (this.isRequired = this.dataset.required === "true"),
      (this.isText = true),
      (this.notMain = this.dataset.notMain === "true");
    if (this.dataset.type === "select" || this.dataset.type === "pills") this.isText = ![];
    this.createInputs();
    this.isRequired &&
      this.isText &&
      ((this.isValid = true),
      (this.atcButtons = this.notMain
        ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section)
        : document.querySelectorAll(".main-product-atc")),
      (this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section)),
      (this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label")),
      (this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error")),
      (this.atcErrorMsg = this.dataset.atcErrorMsg),
      (this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 0x1),
      (this.mainAtcBtnError.innerHTML = this.atcErrorMsg),
      (this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true"),
      (this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section)),
      this.applyStickyAtcError &&
        this.stickyAtcButton &&
        ((this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label")),
        (this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error")),
        (this.stickyAtcBtnError.innerHTML = this.atcErrorMsg)),
      this.validateValue(this.prevValue, null));
    if (this.input) this.input.addEventListener("input", this.handleChange.bind(this));
    this.inputRadios.forEach((_0x5245b2) => {
      _0x5245b2.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) this.select.addEventListener("change", this.handleChange.bind(this));
  }
  handleChange(_0x2ccc0c) {
    const _0x59fe88 = _0x2ccc0c.target.value.trim();
    if (_0x2ccc0c.target.checkValidity()) this.prevValue = _0x59fe88;
    else {
      _0x2ccc0c.target.value = this.prevValue;
      return;
    }
    (this.dataset.value = _0x59fe88), (this.productFormInput.value = _0x59fe88);
    if (this.isRequired && this.isText) this.validateValue(_0x59fe88, _0x2ccc0c.target);
  }
  validateValue(_0x4fa779, _0x5bc349) {
    const _0x4c0071 = _0x4fa779.length > 0x0 ? true : ![];
    if (_0x4c0071 === this.isValid) return;
    this.isValid = _0x4c0071;
    _0x5bc349 &&
      (this.isValid
        ? (_0x5bc349.classList.remove("input--error"),
          (this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 0x1))
        : (_0x5bc349.classList.add("input--error"),
          (this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 0x1)));
    const _0x4ab241 = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields,
      _0x145b0e = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach((_0x575b58) => {
      _0x4ab241 && !_0x145b0e ? _0x575b58.removeAttribute("disabled") : _0x575b58.setAttribute("disabled", "");
    });
    if (this.atcErrorMsg.length === 0x0) return;
    _0x4ab241
      ? ((this.mainAtcBtnLabel.style.display = ""),
        (this.mainAtcBtnError.style.display = "none"),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel.style.display = ""), (this.stickyAtcBtnError.style.display = "none")))
      : ((this.mainAtcBtnLabel.style.display = "none"),
        (this.mainAtcBtnError.style.display = ""),
        this.applyStickyAtcError &&
          this.stickyAtcButton &&
          ((this.stickyAtcBtnLabel.style.display = "none"), (this.stickyAtcBtnError.style.display = "")));
  }
  createInputs() {
    (this.productFormInput = document.createElement("input")),
      this.productFormInput.setAttribute("type", "hidden"),
      this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]"),
      (this.productFormInput.value = this.dataset.defaultValue),
      this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);

class VariantSelects extends HTMLElement {
  constructor() {
    super(),
      (this.secondarySelectSelector = "StickyAtcVariantPicker-"),
      (this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section)),
      (this.isSecondary = ![]),
      (this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section)),
      (this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true"),
      (this.prependMedia = this.dataset.disablePrepend != "true"),
      (this.filtering = this.dataset.hasFiltering === "true"),
      (this.skipNonExistent = this.dataset.skipNonExistent === "true"),
      (this.skipUnavailable = this.dataset.skipUnavailable === "true"),
      this.hasQuantityBreaksPicker &&
        ((this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle),
        (this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages)),
      this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(true, "", ![]),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) return;
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) return;
      }
      this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl();
    }
  }
  updateOptions() {
    const _0x1f21d7 = [];
    this.querySelectorAll(".product-form__input").forEach((_0x545ae6) => {
      let _0x11ccb3;
      const _0x100841 = _0x545ae6.querySelector(".product-form__input__type").dataset.type;
      _0x100841 == "dropdown" || _0x100841 == "dropdwon"
        ? (_0x11ccb3 = _0x545ae6.querySelector(".select__select").value)
        : (_0x11ccb3 = _0x545ae6.querySelector('input[type="radio"]:checked').value),
        _0x1f21d7.push(_0x11ccb3);
    }),
      (this.options = _0x1f21d7);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((_0x5dedec) => {
      return !_0x5dedec.options
        .map((_0x3160da, _0x3f8488) => {
          return this.options[_0x3f8488] === _0x3160da;
        })
        .includes(![]);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const _0x7d8401 = document.querySelectorAll('[id^="MediaGallery-' + this.dataset.section + "\x22]");
    _0x7d8401.forEach((_0xde8f2e) =>
      _0xde8f2e.setActiveMedia(
        this.dataset.section + "-" + this.currentVariant.featured_media.id,
        this.prependMedia,
        this.filtering,
        this.currentVariant,
      ),
    );
    const _0x4494a4 = document.querySelector(
      "#ProductModal-" + this.dataset.section + " .product-media-modal__content",
    );
    if (!_0x4494a4) return;
    const _0x426414 = _0x4494a4.querySelector("[data-media-id=\x22" + this.currentVariant.featured_media.id + "\x22]");
    _0x4494a4.prepend(_0x426414);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateShareUrl() {
    const _0x3171ac = document.getElementById("Share-" + this.dataset.section);
    if (!_0x3171ac || !_0x3171ac.updateUrl) return;
    _0x3171ac.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateVariantInput() {
    const _0x51ff82 = document.querySelectorAll(
      "#product-form-" + this.dataset.section + ",\x20#product-form-installment-" + this.dataset.section,
    );
    _0x51ff82.forEach((_0x4975f8) => {
      const _0x3795d1 = _0x4975f8.querySelector('input[name="id"]');
      (_0x3795d1.value = this.currentVariant.id),
        _0x3795d1.dispatchEvent(
          new Event("change", {
            bubbles: true,
          }),
        );
    });
  }
  updateVariantStatuses() {
    const _0xdbe13d = this.variantData.filter(
      (_0x278dc7) => this.querySelector(":checked").value === _0x278dc7.option1,
    );
    let _0x377ee6;
    this.isSecondary && this.secondarySelect
      ? (_0x377ee6 = [...this.secondarySelect.querySelectorAll(".product-form__input")])
      : (_0x377ee6 = [...this.querySelectorAll(".product-form__input")]),
      _0x377ee6.forEach((_0x45bc37, _0x4244f5) => {
        if (_0x4244f5 === 0x0) return;
        const _0x833098 = [..._0x45bc37.querySelectorAll('input[type="radio"], .select__select option')],
          _0x3cd43d = _0x377ee6[_0x4244f5 - 0x1].querySelector(":checked").value,
          _0xbb04c8 = _0xdbe13d
            .filter((_0x29ec66) => _0x29ec66.available && _0x29ec66["option" + _0x4244f5] === _0x3cd43d)
            .map((_0x13a46a) => _0x13a46a["option" + (_0x4244f5 + 0x1)]),
          _0x96763b = _0xdbe13d
            .filter((_0x38221a) => _0x38221a["option" + _0x4244f5] === _0x3cd43d)
            .map((_0x4c7173) => _0x4c7173["option" + (_0x4244f5 + 0x1)]);
        this.setInputAvailability(_0x833098, _0xbb04c8, _0x96763b);
      });
  }
  setInputAvailability(_0x5e8645, _0x27409d, _0x1ce300) {
    _0x5e8645.forEach((_0x2fd1ac) => {
      _0x2fd1ac.classList.remove("unavailable", "non-existent", "disabled");
      const _0x18c1ac = _0x2fd1ac.getAttribute("value");
      let _0x3ecb2a = null;
      _0x2fd1ac.dataset.swatch === "true" && (_0x3ecb2a = _0x2fd1ac.closest(".color-swatch"));
      if (_0x3ecb2a) _0x3ecb2a.classList.remove("unavailable", "non-existent", "disabled");
      if (_0x1ce300.includes(_0x18c1ac)) {
        if (_0x27409d.includes(_0x18c1ac)) {
          if (_0x2fd1ac.nodeName === "OPTION") _0x2fd1ac.innerText = _0x18c1ac;
          else {
            _0x2fd1ac.classList.remove("disabled");
            if (_0x3ecb2a) _0x3ecb2a.classList.remove("disabled");
          }
        } else {
          if (_0x2fd1ac.nodeName === "OPTION")
            (_0x2fd1ac.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x18c1ac)),
              _0x2fd1ac.classList.add("unavailable");
          else {
            _0x2fd1ac.classList.add("disabled", "unavailable");
            if (_0x3ecb2a) _0x3ecb2a.classList.add("disabled", "unavailable");
          }
        }
      } else {
        if (_0x2fd1ac.nodeName === "OPTION")
          (_0x2fd1ac.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x18c1ac)),
            _0x2fd1ac.classList.add("non-existent");
        else {
          _0x2fd1ac.classList.add("disabled", "non-existent");
          if (_0x3ecb2a) _0x3ecb2a.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    const _0xdac560 = document.querySelector("pickup-availability");
    if (!_0xdac560) return;
    if (this.currentVariant && this.currentVariant.available) {
      if (_0xdac560.fetchAvailability) _0xdac560.fetchAvailability(this.currentVariant.id);
    } else _0xdac560.removeAttribute("available"), (_0xdac560.innerHTML = "");
  }
  removeErrorMessage() {
    const _0x4792da = this.closest("section");
    if (!_0x4792da) return;
    const _0x6f00fa = _0x4792da.querySelector("product-form");
    if (_0x6f00fa) _0x6f00fa.handleErrorMessage();
  }
  renderProductInfo() {
    const _0x3be321 = this.currentVariant.id,
      _0x58b005 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(
      this.dataset.url +
        "?variant=" +
        _0x3be321 +
        "&section_id=" +
        (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
    )
      .then((_0x34e10e) => _0x34e10e.text())
      .then((_0x44e7e8) => {
        if (this.currentVariant.id !== _0x3be321) return;
        const _0xc62236 = new DOMParser().parseFromString(_0x44e7e8, "text/html"),
          _0x408ccb = document.getElementById("price-" + this.dataset.section),
          _0x48aa17 = _0xc62236.getElementById(
            "price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          _0x18129b = document.getElementById("sticky-atc-separate-price-" + this.dataset.section),
          _0x3bd91f = _0xc62236.getElementById(
            "sticky-atc-separate-price-" +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          _0x18e735 = document.getElementById("sticky-atc-price-" + this.dataset.section),
          _0x51f8f7 = _0xc62236.getElementById(
            "sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          _0x2a3bfc = document.getElementById("sticky-atc-image-" + this.dataset.section),
          _0x2d24de = _0xc62236.getElementById(
            "sticky-atc-image-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          _0x1d7d3b = document.getElementById("main-atc-price-" + this.dataset.section),
          _0x3383aa = _0xc62236.getElementById(
            "main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          _0x335eaf = document.querySelectorAll("[id^=\x22custom-label-" + this.dataset.section + "\x22]"),
          _0x45175a = _0xc62236.querySelectorAll(
            '[id^="custom-label-' +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) +
              "\x22]",
          ),
          _0x4c96dd = _0xc62236.getElementById(
            "Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          _0x1844a4 = document.getElementById("Sku-" + this.dataset.section),
          _0x6ca41b = _0xc62236.getElementById(
            "Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          ),
          _0x4f496b = document.getElementById("Inventory-" + this.dataset.section);
        if (_0x408ccb && _0x48aa17) _0x408ccb.innerHTML = _0x48aa17.innerHTML;
        if (_0x18129b && _0x3bd91f) _0x18129b.innerHTML = _0x3bd91f.innerHTML;
        if (_0x18e735 && _0x51f8f7) _0x18e735.innerHTML = _0x51f8f7.innerHTML;
        if (_0x2a3bfc && _0x2d24de) _0x2a3bfc.src = _0x2d24de.src;
        if (_0x3383aa && _0x1d7d3b) _0x1d7d3b.innerHTML = _0x3383aa.innerHTML;
        if (_0x335eaf && _0x45175a)
          for (var _0x4cc815 = 0x0; _0x4cc815 < _0x335eaf.length; _0x4cc815++) {
            _0x335eaf[_0x4cc815].innerHTML = _0x45175a[_0x4cc815].innerHTML;
          }
        if (_0x6ca41b && _0x4f496b) _0x4f496b.innerHTML = _0x6ca41b.innerHTML;
        _0x4c96dd &&
          _0x1844a4 &&
          ((_0x1844a4.innerHTML = _0x4c96dd.innerHTML),
          _0x1844a4.classList.toggle("visibility-hidden", _0x4c96dd.classList.contains("visibility-hidden")));
        if (this.QuantityBreaks) {
          const _0x6918f3 = _0xc62236.getElementById(
              "quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
            ),
            _0x2e699f = this.QuantityBreaks.querySelectorAll(".dynamic-price"),
            _0x265bbe = _0x6918f3.querySelectorAll(".dynamic-price");
          for (let _0x1fcec4 = 0x0; _0x1fcec4 < _0x2e699f.length; _0x1fcec4++) {
            _0x2e699f[_0x1fcec4].innerHTML = _0x265bbe[_0x1fcec4].innerHTML;
          }
          if (this.QuantityBreaks.hasVariants) {
            this.QuantityBreaks.variantSelects.forEach((_0x47f465) => {
              _0x47f465.dataset.selectedId = this.currentVariant.id;
            });
            const _0x2314a7 = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select"),
              _0x50c658 = _0x6918f3.querySelectorAll(".quantity-break__variant-select");
            for (let _0x4bf01a = 0x0; _0x4bf01a < _0x2314a7.length; _0x4bf01a++) {
              _0x2314a7[_0x4bf01a].innerHTML = _0x50c658[_0x4bf01a].innerHTML;
            }
            this.QuantityBreaks.initVariants();
          }
        }
        if (this.hasQuantityBreaksPicker) {
          const _0x34c7f8 = _0xc62236.getElementById(
              "variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
            ),
            _0x138849 = this.querySelectorAll(".dynamic-price"),
            _0xf06d69 = _0x34c7f8.querySelectorAll(".dynamic-price");
          for (let _0x349476 = 0x0; _0x349476 < _0x138849.length; _0x349476++) {
            _0x138849[_0x349476].innerHTML = _0xf06d69[_0x349476].innerHTML;
          }
          if (
            this.quantityBreaksPickerStyle === "vertical" &&
            this.quantityBreaksPickerDisplayedImages === "variant_images"
          ) {
            const _0xf5a2ed = this.querySelectorAll(".quantity-break__image\x20img"),
              _0x396ff2 = _0x34c7f8.querySelectorAll(".quantity-break__image img");
            for (let _0x57843e = 0x0; _0x57843e < _0xf5a2ed.length; _0x57843e++) {
              _0xf5a2ed[_0x57843e].src = _0x396ff2[_0x57843e].src;
            }
          }
        }
        if (this.secondarySelect) {
          const _0x1f215b = _0xc62236.getElementById(
            "" +
              this.secondarySelectSelector +
              (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section),
          );
          if (_0x1f215b) this.secondarySelect.innerHTML = _0x1f215b.innerHTML;
        }
        const _0x544292 = document.getElementById("price-" + this.dataset.section);
        if (_0x544292) _0x544292.classList.remove("visibility-hidden");
        if (_0x4f496b) _0x4f496b.classList.toggle("visibility-hidden", _0x6ca41b.innerText === "");
        const _0x68ba79 = _0xc62236.getElementById("ProductSubmitButton-" + _0x58b005);
        this.toggleAddButton(_0x68ba79 ? _0x68ba79.hasAttribute("disabled") : true, window.variantStrings.soldOut),
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: _0x58b005,
              html: _0xc62236,
              variant: this.currentVariant,
            },
          });
      });
  }
  toggleAddButton(_0x503b90 = true, _0x52e8b0, _0x25a97d = true) {
    const _0x28b86c = document.getElementById("product-form-" + this.dataset.section);
    if (!_0x28b86c) return;
    const _0x56c9fb = _0x28b86c.querySelector('[name="add"]'),
      _0x46db95 = document.querySelectorAll(".main-product-atc");
    var _0x302424 = _0x28b86c.querySelector(".main-atc__label__text");
    if (!_0x302424) _0x302424 = _0x28b86c.querySelector(".main-atc__label");
    const _0x1e5c72 = _0x28b86c.querySelector(".main-atc-price");
    if (!_0x56c9fb) return;
    if (_0x503b90) {
      _0x56c9fb.setAttribute("disabled", "disabled"), _0x56c9fb.setAttribute("data-unavailable", "true");
      if (_0x52e8b0) _0x302424.textContent = _0x52e8b0;
      _0x46db95.forEach((_0x3b1bf8) => {
        _0x3b1bf8.setAttribute("disabled", "disabled");
      });
      if (_0x1e5c72) _0x1e5c72.classList.add("hidden");
    } else {
      _0x56c9fb.setAttribute("data-unavailable", "false"), (_0x302424.textContent = window.variantStrings.addToCart);
      if (_0x1e5c72) _0x1e5c72.classList.remove("hidden");
      _0x56c9fb.dataset.requiredFields === _0x56c9fb.dataset.validFields &&
        (_0x56c9fb.removeAttribute("disabled"),
        _0x46db95.forEach((_0x32d191) => {
          _0x32d191.removeAttribute("disabled");
        }));
    }
    if (!_0x25a97d) return;
  }
  setUnavailable() {
    const _0x54a361 = document.getElementById("product-form-" + this.dataset.section);
    if (!_0x54a361) return;
    const _0x275300 = _0x54a361.querySelector('[name="add"]');
    var _0x23fdcc = _0x54a361.querySelector(".main-atc__label__text");
    if (!_0x23fdcc) _0x23fdcc = _0x54a361.querySelector(".main-atc__label");
    const _0x4f9e89 = document.getElementById("price-" + this.dataset.section),
      _0x4741f0 = document.getElementById("Inventory-" + this.dataset.section),
      _0x50ad37 = document.getElementById("Sku-" + this.dataset.section);
    if (!_0x275300) return;
    _0x23fdcc.textContent = window.variantStrings.unavailable;
    if (_0x4f9e89) _0x4f9e89.classList.add("visibility-hidden");
    if (_0x4741f0) _0x4741f0.classList.add("visibility-hidden");
    if (_0x50ad37) _0x50ad37.classList.add("visibility-hidden");
  }
  getVariantData() {
    return (
      (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)),
      this.variantData
    );
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super(),
      (this.secondarySelectSelector = "variant-selects-"),
      (this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section)),
      (this.isSecondary = true);
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super(),
      (this.secondarySelectSelector = "variant-selects-"),
      (this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section)),
      (this.isSecondary = true);
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super(), (this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit"));
  }
  onVariantChange() {
    this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(true, "", ![]),
      this.updateVariantStatuses(),
      !this.currentVariant
        ? (this.toggleAddButton(true, "", true), this.setUnavailable())
        : (this.updateMedia(),
          this.updateVariantInput(),
          this.updateQuickAddUrl(),
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut));
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const _0x5bb1f8 = document.getElementById(this.dataset.section + "-image");
    if (!_0x5bb1f8) return;
    const _0x2e9bb6 = this.currentVariant.featured_media.preview_image,
      _0x485ffc = _0x2e9bb6.src.split("?")[0x0],
      _0x1d5cb0 = [0xa5, 0x168, 0x215, 0x2d0, 0x3ac, 0x42a],
      _0x1acfa8 = _0x1d5cb0
        .filter((_0x5a54c7) => _0x2e9bb6.width >= _0x5a54c7)
        .map((_0x5b4ab6) => _0x485ffc + "?width=" + _0x5b4ab6 + "\x20" + _0x5b4ab6 + "w")
        .join(",\x20");
    (_0x5bb1f8.srcset = _0x1acfa8 + ",\x20" + _0x485ffc + "\x20" + _0x2e9bb6.width + "w"),
      (_0x5bb1f8.src = _0x485ffc + "?width=533");
  }
  updateQuickAddUrl() {
    if (!this.currentVariant || !this.quickAddSubmit) return;
    this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
  }
}
customElements.define("card-variant-selects", CardVariantSelects);
